goog.provide('el8.appchart.visitNote.main');

goog.require('el8.data.checklistTemplates');
goog.require('el8.data.educationalHandouts');
goog.require('el8.data.imos');
goog.require('el8.data.serviceLocations');
goog.require('el8.data.visitNoteFormTemplates');
goog.require('el8.data.visitNoteSectionNames');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.ptdata.historyItems');
goog.require('el8.ptdata.ptAllergies');
goog.require('el8.ptdata.ptNextAppt');
goog.require('el8.ptdata.ptProblems');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.dialog.addProblemDetailDialog');
goog.require('el8.appchart.dialog.manualLabEntry');
goog.require('el8.appchart.dialog.removeOrder');
goog.require('el8.appchart.dialog.setDateTime');
goog.require('el8.appchart.dialog.visitNoteTemplates');
goog.require('el8.appchart.dialog.visitNoteTemplateEdit');
goog.require('el8.appchart.mainFeeds.chartFileUploader');
goog.require('el8.appchart.refpanel.demog');
goog.require('el8.appchart.refpanel.util');
goog.require('el8.appchart.showItemDetail');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.docTags.tooltips');
goog.require('el8.service.infoField');
goog.require('el8.service.pageunload');
goog.require('el8.service.tooltip');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.app.data.checklistTemplates');
goog.require('el8.template.appchart.visitNote');
goog.require('el8.template.appshared.docTags');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.uiwidget.LegacyMindreader');
goog.require('el8.uiwidget.multilist');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.base');
goog.require('el8.util.consts');
goog.require('el8.util.feed');
goog.require('el8.util.string');
goog.require('el8.util.amplitude.helpers');

goog.require('el8.appchart.visitNote.alertFeed');
goog.require('el8.appchart.visitNote.billDialogMgr');
goog.require('el8.appchart.visitNote.checklist');
goog.require('el8.appchart.visitNote.labsProblemsDialog');
goog.require('el8.appchart.visitNote.section');
goog.require('el8.appchart.visitNote.subBulletDialog');
goog.require('el8.appchart.visitNote.timer');
goog.require('el8.appchart.visitNote.util');
goog.require('el8.appchart.visitNote.vitals');
goog.require('el8.appchart.visitNote.vitalsProcessor');


el8.appchart.visitNote.main = (function () {

    // TODO this file has several functions with > 4 params.
    // Refactoring them is a pain because they're widely used, so I'm
    // turning off that check in this file rather than turning off the check
    // completely. They should really use a dict of opts instead.

    var threePaneActive = null;

    var bulletHighlightFn = function (bullet) {
        return (bullet && bullet.isEditedByVnt());
    };

    var cptMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.cptCodes(), {
        formatSelected: function (item) { return item.description; },
        selectFn: function (event, item) {
            if (el8Globals.FEATURES.AutoImportBilling) {
                el8.appchart.visitNote.main.appendBillingCpt({ id: item.id });
            }
        },
        shouldItemHighlightFn: bulletHighlightFn
    });

    var findPastChecklistFn = function (type) {
        that._checklists[type].populateFromPrevNote();
    };
    var checklistSelectFn = function (type, item) {
        if (!that._checklists) { return; } // that = visitNote.main module
        var template = el8.data.checklistTemplates.getById(item.id);
        that._checklists[type].populateTemplate(template);
    };
    var peMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.checklistTemplates('pe'), {
        selectFn: function (event, item) { checklistSelectFn.call(this, 'pe', item); },
        actionsFirst: true,
        actions: [
            {
                name: 'Last Documented PE',
                actionFn: function () { findPastChecklistFn('pe'); }
            }
        ],
        shouldItemHighlightFn: bulletHighlightFn
    });
    var rosMindreaderOpts = $.extend(el8.appshared.mindreaderOpts.checklistTemplates('ros'), {
        selectFn: function (event, item) { checklistSelectFn.call(this, 'ros', item); },
        actionsFirst: true,
        actions: [
            {
                name: 'Last Documented ROS',
                actionFn: function () { findPastChecklistFn('ros'); }
            }
        ],
        shouldItemHighlightFn: bulletHighlightFn
    });

    /**
     * selectFn helper to add a VN bullet to sectionName after IMO diagnosis selection
     * @param {*} event
     * @param {DxNavIMOSearchResult} item
     * @param {*} mr
     * @param {*} mlEntry
     * @param {string} sectionName
     */
    var selectImoDiagnosisHelper = function (event, item, mr, mlEntry, sectionName) {
        // Validate target multilist exists
        var section = that._inputSections[sectionName.toLowerCase()];
        if (!section.isMultilist()) {
            UIM && UIM.logError('Visit IMO section being used without multilist');
            return;
        }

        var imo = el8.data.imos.getLatestImoByKey(item.imo_code, item.icd10);

        var bullet;

        // FUTURE: Prevent selection (short-circuit vs. throw?) if initial term
        // or fetched IMO is considered non-billable on date of service.
        // Previous "disabled" behavior was a bug: item.prop(...) throws error!

        // Edit the existing entry, if one exists
        if (mlEntry) {
            // Lame hack to prevent the bullet from getting
            // cleared out when we return '' above
            // (Relies on multilistEntry's saveParent aborting when it sees this)
            mlEntry._isSaving = true;

            var existingBulletId = mlEntry.getParentId();
            var bulletSet = that._model.getBulletSets()[sectionName.toUpperCamel()];
            bullet = bulletSet.getById(existingBulletId);

            bullet.setText(item.title);
            bullet.setImoIds([imo.getId()]);
            bulletSet.saveItem(bullet, false, {
                // must be synchronous to fix https://elationhealth.atlassian.net/browse/RM-40466
                // see commit message for more on why we settled on this bad practice here
                async: false,
                successCb: function () {
                    section._widget.rerenderParent(mlEntry, bullet);
                    mlEntry.activateSublist();
                    mlEntry._isSaving = false;
                },
                errorCb: function () {
                    mlEntry._isSaving = false;
                }
            });

            // Otherwise add the new bullet, with structured codes
            // if the user has that setting on
        } else {
            var bulletSpec = { 'text': item.title };
            if (el8.data.currUser.isStructuredAssessmentsEnabled()) {
                bulletSpec.imoIds = [imo.getId()];
            }
            bullet = that._model.addBullet(sectionName.toUpperCamel(), bulletSpec);
            that._inputSections[sectionName.toLowerCase()].addEntry(bullet, false, {
                successCb: function () {
                    var mlEntry = section._widget.getLastEntry();
                    mlEntry.activateSublist();
                }
            });
        }

        if (el8Globals.FEATURES.AutoImportBilling) {
            // and then add the code to the billing section
            el8.appchart.visitNote.main.appendBillingDiagnoses({
                imoIds: [imo.getId()]
            });
        }
    }

    var imoMindreaderOptsFn = function (sectionName) {
        return $.extend(el8.appshared.mindreaderOpts.imosWithActiveAndRecentSignedProblems('icd10', true), {
            formatSelected: function (item) {
                if (item.model_class === 'ICD10Code') {
                    // there won't be a structured code for fallback ICD10s
                    return item.description;
                }
                // We'll use the selectFn to add a structured
                // version of any IMO results
                return '';
            },
            selectFn: function (event, item, mr, mlEntry) {

                // User selected a diagnosis from mindreader
                if (item.imo_code) {

                    // FUTURE: Use practice setting to determine if we should auto-split IMO codes
                    if (el8Globals.FEATURES.DxSplitConfig && item.should_split) {

                        // FUTURE: What should we do if getSplitImoCodes() lookup has error?
                        // FUTURE: What should we do if getSplitImoCodes() returns bundle itself?
                        // Additional, IMO Core search w/ `singleCodeOnly` may return ICD-10 code
                        // but you will pay additional O(n) network cost to check.
                        var splitImos = el8.data.imos.getSplitImoCodes("" + item.imo_code);

                        // FUTURE: Should getSplitImoCodes() return transformed items?
                        // FUTURE: Is risk score for hcc_community_factors needed to add VN bullet?
                        var splitItems = splitImos.map(function (imoDetail) {
                            return {
                                icd10: imoDetail.PROBIT_BASE_TEXT_CODE,
                                imo_code: imoDetail.PREF_LEX_TEXT_IMO_CODE,
                                more_icd10: false,
                                snomed_description: '',
                                snomed: '',
                                title: imoDetail.BASE_TEXT,
                            }
                        });

                        splitItems.forEach(function (item, index) {
                            selectImoDiagnosisHelper(event, item, mr, mlEntry, sectionName);
                        });
                        return;
                    }

                    // Add IMO diagnosis as new VN bullet
                    selectImoDiagnosisHelper(event, item, mr, mlEntry, sectionName);

                } else if (item.model_class === 'ICD10Code' &&
                    el8Globals.FEATURES.AutoImportBilling) {
                    var dxMap = {
                        icd10Code: el8.data.icd10Codes.getById(item.id).asSoyMap()
                    };
                    el8.appchart.visitNote.main.appendBillingDxMaps([dxMap]);
                }
            },
            /**
             * Handler to enable mindreader to capture a free text entry, create a VN bullet, and map the input value to the new bullet
             * Used with `BillDxNavMindreader` in VNs with an `Assessment/Plan` section
             * @param {string} freeTextValue - The mindreader free text input value
             */
            selectFreeTextFn: function (freeTextValue) {
                var cleanedValue = el8.util.string.cleanMultiByteChars(freeTextValue);
                var bulletSpec = { 'text': cleanedValue };
                var bullet = that._model.addBullet(sectionName.toUpperCamel(), bulletSpec);
                var section = that._inputSections[sectionName.toLowerCase()];
                section.addEntry(bullet, false, {
                    successCb: function () {
                        var mlEntry = section._widget.getLastEntry();
                        mlEntry.activateSublist();
                    }
                });
            },
            hideNoResults: true,
            overflowInputToLeft: true
        });
    };

    /**
     * Handler when user triggers "Add Problem" to create a problem from the current bullet.
     */
    var addProblemHandler = function (sectionName) {

        return function (bulletId, text, children, removeTriggerFn, $triggerElt) {

            sectionName = sectionName.toUpperCamel();
            var note = el8.appchart.visitNote.main.getNote();
            var bullet = note.getBulletSets()[sectionName].getById(bulletId);

            var description = text;
            var details = children.join('\n');

            var onProblemCreation = function (ptProb) {
                // link this bullet to the new problem
                bullet.setPatientItemId(ptProb.getId());
                bullet.setEditId(note.getCurrentEditId());
                note.getBulletSets()[sectionName].saveItem(bullet);
            };

            if (bullet.getImoIds() && bullet.getImoIds().length) {
                // If we have IMOs on this bullet already, we'll just
                // create a problem right away
                var newProblem = el8.ptdata.ptProblems.create({
                    startDate: el8.service.tz.today(),
                    description: description,
                    details: details,
                    status: 'Active',
                    imoIds: bullet.getImoIds()
                });
                el8.ptdata.ptProblems.saveItem(newProblem, false, {
                    successCb: function (item) {
                        onProblemCreation(item);
                        el8.appchart.refpanel.util.highlightEntry(item.getId());

                        // Refresh the pt hcc score
                        el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
                    }
                });

            } else {
                // If we don't yet have structured codes, we'll open
                // the problem dialog with some pre-populated data
                // and encourage the user to select a code
                el8.appchart.dialog.addEditProblem.show({
                    description: description,
                    details: details,
                    saveCb: onProblemCreation
                });
            }
            removeTriggerFn();
        };
    };

    var imoAnnotationFn = function (bullet) {
        if (!bullet || !bullet.getImoIds().length) { return ''; }

        return el8.template.uiwidget.multilist.imoAnnotation({
            imos: bullet.getImoCodeObjs(true).map(el8.model.toSoyMapFn),
            isShowDualCoding: el8.data.currUser.isShowDualCodingEnabled()
        });
    };

    var sectionsMap = {
        'data': {
            infoText: 'data reviewed...',
            listeditorOpts: {
                triggerMap: {
                    'View': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Data'].getById(bulletId);
                        el8.appchart.showItemDetail(bullet.getDocumentId());
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getDocumentId()) ? 'View' : '';
                },
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'objective': {
            infoText: 'objective...',
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'instr': {
            infoText: 'goals/plan for patient...',
            multilistOpts: {
                childTriggerMap: {
                    'Download': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Instr'].getChildById(bulletId);
                        el8.data.educationalHandouts.downloadById(bullet.getHandoutId());
                    }
                },
                getChildItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getHandoutId() ? 'Download' : '');
                },
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'procedure': {
            infoText: 'procedure administered...',
            mindreaderOpts: cptMindreaderOpts,
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'pe': {
            infoText: 'physical exam findings...',
            mindreaderOpts: peMindreaderOpts,
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'ros': {
            infoText: 'review of systems...',
            mindreaderOpts: rosMindreaderOpts,
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'med': {
            infoText: 'meds reviewed...',
            listeditorOpts: {
                triggerMap: {
                    'View': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Med'].getById(bulletId);
                        el8.appchart.showItemDetail(bullet.getDocumentId());
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getDocumentId()) ? 'View' : '';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            multilistOpts: {
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'plan': {
            infoText: 'plan...',
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'test': {
            infoText: 'tests ordered...',
            listeditorOpts: {
                triggerMap: {
                    'View': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Test'].getById(bulletId);
                        el8.appchart.showItemDetail(bullet.getDocumentId());
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getDocumentId()) ? 'View' : '';
                },
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'tx': {
            infoText: 'treatments prescribed...',
            listeditorOpts: {
                triggerMap: {
                    'View': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Tx'].getById(bulletId);
                        el8.appchart.showItemDetail(bullet.getDocumentId());
                    },
                    'Download': function (bulletId) {
                        var note = el8.appchart.visitNote.main.getNote();
                        var bullet = note.getBulletSets()['Tx'].getById(bulletId);
                        el8.data.educationalHandouts.downloadById(bullet.getHandoutId());
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getDocumentId()) ? 'View' :
                        ((bullet && bullet.getHandoutId()) ? 'Download' : '');
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            mindreaderOpts: {
                data: [
                    "Flu shot Novartis 111799P1 im LD, VIS '10",
                    "TdaP Adacel Sanofi Pasteur C3476AA im LD, VIS '08",
                    "PNA shot Pneumovax Mercke 0449Z im LD, VIS '97",
                    "Discussed the Diagnoses and Treatments",
                    "Discussed the Diagnoses and Treatments at length"
                ],
                stickyListInput: true
            }
        },
        'problem': {
            infoText: 'symptoms and HPI...',
            multilistOpts: {
                labelIfEmpty: 'Prob:',
                // these below handles the permanently blue highlighting for the fields
                // populated by exporting visit note template
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'past': {
            infoText: 'past medical history...',
            listeditorOpts: {
                triggerMap: {
                    'add PMH': function (bulletId, text, removeTriggerFn) {
                        el8.ptdata.historyItems['past'].saveNew(
                            { text: text }, false, {
                            successCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Past'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Past'].saveItem(bullet);
                            }
                        }
                        );
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add PMH';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            mindreaderOpts: {
                data: function () {
                    return el8.ptdata.historyItems.past.all().map(function (a) { return a.getText(); });
                },
                stickyListInput: true
            },
            multilistOpts: {
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            textareaOpts: {
                rows: 2
            }
        },
        'surgical': {
            infoText: 'past surgical history...',
            listeditorOpts: {
                triggerMap: {
                    'add PSH': function (bulletId, text, removeTriggerFn) {
                        el8.ptdata.historyItems['surgical'].saveNew(
                            { text: text }, false, {
                            successCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Surgical'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Surgical'].saveItem(bullet);
                            }
                        }
                        );
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add PSH';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            multilistOpts: {
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            mindreaderOpts: {
                data: function () {
                    return el8.ptdata.historyItems.surgical.all().map(function (a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2
            }
        },
        'family': {
            infoText: 'family history...',
            listeditorOpts: {
                triggerMap: {
                    'add FH': function (bulletId, text, removeTriggerFn) {
                        el8.ptdata.historyItems['family'].saveNew(
                            { text: text }, false, {
                            successCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Family'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Family'].saveItem(bullet);
                            }
                        }
                        );
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add FH';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            mindreaderOpts: {
                data: function () {
                    return el8.ptdata.historyItems.family.all().map(function (a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2,
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'social': {
            infoText: 'social history...',
            listeditorOpts: {
                triggerMap: {
                    'add SH': function (bulletId, text, removeTriggerFn) {
                        el8.ptdata.historyItems['social'].saveNew(
                            { text: text }, false, {
                            successCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Social'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Social'].saveItem(bullet);
                            }
                        }
                        );
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add SH';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            mindreaderOpts: {
                data: function () {
                    return el8.ptdata.historyItems.social.all().map(function (a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2,
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'assessment': {
            infoText: 'assessment...',
            multilistOpts: {
                parentTriggerMap: {
                    'add Problem': addProblemHandler('assessment')
                },
                getParentItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add Problem';
                },
                getItemAnnotationFn: imoAnnotationFn,
                childTriggerMap: {
                    'add Synopsis': function (bulletId, text) {
                        /* Format bullet text with today's date in front */
                        text = el8.service.tz.today().asString() + ': ' + text;
                        el8.appchart.dialog.addProblemDetailDialog.show(text);
                    }
                },
                getChildItemTriggerFn: function () { return 'add Synopsis'; },
                mindreaderOpts: imoMindreaderOptsFn('assessment'),
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            },
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'assessplan': {
            infoText: 'assessment/plan...',
            multilistOpts: {
                parentTriggerMap: {
                    'add Problem': addProblemHandler('assessplan')
                },
                getParentItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add Problem';
                },
                getItemAnnotationFn: imoAnnotationFn,
                childTriggerMap: {
                    'add Synopsis': function (bulletId, text) {
                        /* Format bullet text with today's date in front */
                        text = el8.service.tz.today().asString() + ': ' + text;
                        el8.appchart.dialog.addProblemDetailDialog.show(text);
                    }
                },
                getChildItemTriggerFn: function () { return 'add Synopsis'; },
                mindreaderOpts: imoMindreaderOptsFn('assessplan'),
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            }
        },
        'reason': {
            infoText: 'reason for exam...',
            textareaOpts: {
                wrapperClass: 'el8FieldExtraLongLabelPadding',
                shouldItemHighlightFn: bulletHighlightFn,
                separator: ' '
            }
        },
        'followup': {
            infoText: 'follow up...',
            height: 2 * el8.util.consts.DEFAULT_FIELD_HEIGHT,
            maxLength: 5000,
            textareaOpts: {
                wrapperClass: 'el8FieldShortLabelPadding',
                shouldItemHighlightFn: bulletHighlightFn,
                separator: ' '
            },
            mindreaderOpts: {
                data: [
                    'Follow up in 2 weeks',
                    'Follow up in 6 months',
                    'Follow up in 1 month'
                ],
                entryHeight: 25
            }
        },
        'narrative': {
            infoText: 'HPI narrative...',
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'hpi': {
            infoText: 'HPI narrative...',
            textareaOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'allergies': {
            infoText: 'allergies...',
            listeditorOpts: {
                triggerMap: {
                    'add Allgy': function (bulletId, text, removeTriggerFn) {
                        el8.appchart.dialog.addEditAllergy.show({
                            description: text,
                            saveCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Allergies'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Allergies'].saveItem(bullet);
                            }
                        });
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add Allgy';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            multilistOpts: {
                parentTriggerMap: {
                    'add Allgy': function (bulletId, text, children, removeTriggerFn, $triggerElt) {
                        el8.appchart.dialog.addEditAllergy.show({
                            description: text,
                            saveCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Allergies'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Allergies'].saveItem(bullet);
                            }
                        });
                        removeTriggerFn();
                    }
                },
                getParentItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add Allgy';
                },
                shouldParentHighlightFn: bulletHighlightFn,
                listeditorOpts: {
                    shouldItemHighlightFn: bulletHighlightFn
                }
            }
        },
        'habits': {
            infoText: 'habits...',
            listeditorOpts: {
                triggerMap: {
                    'add Habits': function (bulletId, text, removeTriggerFn) {
                        el8.ptdata.historyItems['habits'].saveNew(
                            { text: text }, false, {
                            successCb: function (item) {
                                var note = el8.appchart.visitNote.main.getNote();
                                var bullet = note.getBulletSets()['Habits'].getById(bulletId);
                                bullet.setPatientItemId(item.getId());
                                bullet.setEditId(note.getCurrentEditId());
                                note.getBulletSets()['Habits'].saveItem(bullet);
                            }
                        }
                        );
                        removeTriggerFn();
                    }
                },
                getItemTriggerFn: function (bullet) {
                    return (bullet && bullet.getRefId()) ? '' : 'add Habits';
                },
                shouldItemHighlightFn: bulletHighlightFn
            },
            mindreaderOpts: {
                data: function () {
                    return el8.ptdata.historyItems.habits.all().map(function (a) { return a.getText(); });
                },
                stickyListInput: true
            },
            textareaOpts: {
                rows: 2,
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'dateprocedure': {
            infoText: 'date of procedure...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                shouldItemHighlightFn: bulletHighlightFn,
                separator: ' '
            }
        },
        'consultant': {
            infoText: 'name of consultant...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                shouldItemHighlightFn: bulletHighlightFn,
                separator: ' '
            }
        },
        'attending': {
            infoText: 'attending physician...',
            textareaOpts: {
                wrapperClass: 'el8FieldLongLabelPadding',
                shouldItemHighlightFn: bulletHighlightFn,
                separator: ' '
            }
        },
        'referenced': {
            sectionSelector: '#visit-note-section-referenced',
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        },
        'orders': {
            sectionSelector: '#visit-note-section-orders',
            listeditorOpts: {
                shouldItemHighlightFn: bulletHighlightFn
            }
        }
    };

    var that = {

        getCurrFormTemplate: function () {
            return el8.appchart.visitNote.util.getCurrFormTemplate(this._currTemplate);
        },

        _init: function () {

            if (this._isInit) { return; }
            var that = this;

            this._isOpen = false;
            this._container = $('#third-pane-container');
            this._bindTriggers();
            this._bpCount = 0;

            // Make sure we don't lose anything if somebody accidentally
            // closes the window
            el8.service.pageunload.add(function () {
                that._unloadBlurAll();
                that._lastDitchSave();
                that._saveTimers(false, true);
            });

            // the procedure autocomplete won't support show-on-focus until the CPTs are loaded
            // but we don't really need to hold notes up because of that... so we can do it async
            el8.data.cptCodes.softLoad(null, true);

            this._isInit = true;
        },

        _addVitals: function (name, fields, vitalClass, selector) {
            var that = this;
            var opts = {
                note: this._model,
                name: name,
                form: this._form,
                fields: fields,
                vitalClass: vitalClass,
                selector: selector,
                container: this._container,
                cleanInputFn: el8.appchart.visitNote.vitalFields.getCleanInputFn(name, that._vitalsProcessor),
                saveCb: function (vital) { },
                vitalsProcessor: that._vitalsProcessor,
                valueChangeFn: function () { el8.appchart.cqmRefresh.forceRefresh(false); }
            };
            this._vitals[name] = new el8.appchart.visitNote.vitals(opts).create();
        },

        _addBpInput: function (bp) {
            this._bpCount++;  // init at 0, but 0th shows by default so we start at #1
            $('.bp-section', this._container).append(
                el8.template.appchart.visitNote.bpInput({ 'index': this._bpCount })
            );
            this._addVitals('bp_' + this._bpCount, el8.appchart.visitNote.vitalFields.getBpFields(this._bpCount),
                'bp', '.bp-input[_bpindex="' + this._bpCount + '"]');
            this._populateVitals('bp_' + this._bpCount, bp || null);
            el8.appchart.visitNote.vitalFields.cleanBpTriggers(this._container);
        },

        _addLinksSection: function (name) {
            $('#visit-note-stub-' + name + '-links', this._container).replaceWith(
                el8.template.appchart.visitNote['links' + name.capitalize()]
            );
        },

        _addInputSection: function (name, type, isHidden) {
            if (sectionsMap[name]) {
                var opts = sectionsMap[name];
                $.extend(opts, {
                    note: this._model,
                    form: this._form,
                    type: type,
                    name: name,
                    isHidden: Boolean(isHidden),
                    templateClass: el8.data.visitNoteFormTemplates.getClass(this._currTemplate)
                });
                this._inputSections[name] = new el8.appchart.visitNote.section(opts).create();

                if (name === 'ros' || name === 'pe') {
                    // don't minimize if hidden, so checklist displayed immediately when shown
                    this._addChecklist(name, !isHidden);
                }
            }
        },

        _addChecklist: function (type, isMinimized) {
            var that = this;
            this._checklists[type] = new el8.appchart.visitNote.checklist({
                note: this._model,
                form: this._form,
                type: type,
                container: $('#' + type.toLowerCase() + '-detail-checklist-form', this._container),
                checklistTrigger: $('#' + type.toLowerCase() + '-detail-checklist-trigger', this._container),
                actionsMenu: this._actionsMenu,
                templatesTrigger: $('#' + type.toLowerCase() + '-detail-templates-trigger', this._container),
                rightAlign: (type === 'pe'),
                sectionShowFn: function () { that._inputSections[type].show(); }
            });
            if (isMinimized) {
                this._checklists[type].minimize();
            } else {
                this._checklists[type].show(false);
            }
        },

        _addBillingSection: function () {
            if (!this._model.getCurrentEditId()) {
                var bill = this._model.getBill();
                $('.billing-summary', this._container).html(
                    el8.template.appchart.visitNote.billSummary({
                        bill: bill ? bill.asSoyMap() : null,
                        patient: el8.ptdata.currPatient.asSoyMap(),
                        isInvoicingEnabled: el8.data.practiceSettings.isInvoicingEnabled(),
                        isPMSIntegrated: el8.data.currPractice.isPMSIntegrated(),
                        isDeferredBillsEnabled: el8.data.practiceSettings.isDeferredBillsEnabled(),
                        billNotesWordsArray: bill ? el8.util.string.getWordObjArray(bill.getNotes()) : [],
                        isVisitNoteSendBillToPmsEnabled: el8.data.practiceSettings.isVisitNoteSendBillToPmsEnabled(),
                    })
                );

            } else {
                $('.visit-note-internal-section', this._container).hide();
            }

            /* Best place to put for now; hover widgets for MU sections */
            $(':input.transition-type', this._container).each(function (index, elt) {
                el8.service.tooltip.create({
                    anchor: $(elt).parent('label'),
                    text: el8.template.appchart.visitNote.muTooltip({ direction: $(elt).val() }),
                    placement: 'bottom'
                });
            });
        },

        _bindTriggers: function () {
            var that = this;

            el8.appchart.mgr.thirdpane.setupViewModeButton();
            // TODO it would probably be better to delegate these on _content and set them
            // up on every show, rather than leaving them hanging around indefinitely on _container
            this._container.on('change', ':input[name="visitNoteType"]', function () {
                that._model.saveType(that._noteTypeElt.val());
                return false;

            }).on('change', ':input[name="physicianId"]', function () {
                that._model.savePhysician(that._physicianElt.val());
                return false;

            }).on('click', '.visit-date-clickable', function (e) {
                e.preventDefault();
                el8.appchart.dialog.setDateTime.show({
                    defaultDateTime: that._model.getDisplayDate(),
                    saveCallbackFn: function (newDateTime) {
                        that._model.saveDocumentDate(newDateTime, function (data) {
                            that.updateVisitDateElt();
                            that._model.setPreviousWeight(data.previous_weight);
                            if (data.weight_delta) {
                                that._model.setWeightDelta(data.weight_delta);
                            }
                            that._model.setPreviousBmi(data.previous_bmi);
                            if (data.bmi_delta) {
                                that._model.setBmiDelta(data.bmi_delta);
                            }
                            that._model.setPreviousTime(data.previous_time);
                            // TODO do we want to update the custom vitals sets here?
                            that._updatePreviousVitals();

                            // Update the CDS display when the date changes
                            el8.appchart.cqmRefresh.setReportingYear(newDateTime.year);
                            el8.appchart.cqmRefresh.forceRefresh(true);

                            var note = el8.appchart.visitNote.main.getNote();
                            el8.data.decisionSupports.load();
                            el8.appchart.visitNote.refreshAlertFeed(note, false);
                        });
                    },
                    title: 'Set Visit Note Date and Time'
                });

            }).on('click', '.enter-poc-result-trigger', function () {
                el8.appchart.dialog.manualLabEntry.show();
                return false;

            }).on('click', '.visit-note-ref-history-button', function () {
                var type = $(this).attr('_type');
                // second param: alert if the section is empty
                el8.appchart.mgr.notes.referenceHistorySection(type, true);
                return false;

            }).on('click', '#visit-note-ref-allergies-button', function () {
                el8.appchart.mgr.notes.referenceAllergies();

            }).on('click', '#visit-note-ref-meds-button', function () {
                el8.appchart.mgr.notes.addMedsListSnapshot(
                    ['perm-rx', 'perm-otc']);
                return false;

            }).on('click', '#visit-note-ref-problems-button', function () {
                el8.appchart.mgr.notes.referenceProblems(['past']);
                return false;

            }).on('click', '#visit-note-ref-problems-labs-button', function () {
                el8.appchart.visitNote.labsProblemsDialog.show(that.getNoteId());
                return false;

            }).on('click', '#note-new-visit-print-instructions-btn', function () {
                if (that._model.getBulletSets()['Instr'].all().length) {
                    window.open(el8Globals['PATIENT_PATH'] + "print/patient-instructions/" + that._model.getId() + "/");
                    that.addText('Instrs printed & given to patient', 'tx');
                } else {
                    el8.uiwidget.alert(
                        'There are no instructions to print',
                        that._form.getInfoField('instr').getInputField()
                    );
                }
                return false;

            }).on('click', '#note-new-visit-print-summary-btn', function () {
                that.printPatientSummary();
                return false;

            }).on('click', '#note-new-visit-print-clinical-summary-btn', function () {
                that.printClinicalSummary();
                return false;

            }).on('click', '.details-trigger', function () {
                var fid = $(this).attr('_fid');
                var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
                el8.appchart.showItemDetail(item);
                return false;

            }).on('click', '.section-show-trigger', function () {
                var section = that._inputSections[$(this).attr('_section')];
                section.show();
                $(this).remove();

            }).on('click', '.vitals-show-trigger', function () {
                that._showVitalsSection();

            }).on('click', '.add-bp-trigger', function () {
                that._addBpInput();

            }).on('click', '.remove-bp-trigger', function () {
                var bpIndex = $(this).attr('_bpindex');
                that._vitals['bp_' + bpIndex].destroy();
                el8.appchart.visitNote.vitalFields.cleanBpTriggers(that._container);

            }).on('click', '.vitals-note-show-trigger', function () {
                var type = $(this).attr('data-type');
                $('.' + type + '-note-section', that._container).show()
                    .find(':input').focusFocus();
                $(this).closest('.vitals-wrapper').remove();

            }).on('click', '#assessments-mark-all-trigger', function () {
                var strs = ['stable', 'OK', 'controlled', 'ongoing', 'poorly controlled'];
                var menu = strs.map(function (str) {
                    return {
                        actionText: str,
                        actionFn: function () {
                            that.markAllAssessments(str);
                        }
                    };
                });
                var offsets = { top: 19, left: 10 };
                that._actionsMenu.display($(this), null, offsets, menu);
                return false;

            }).on('click', '.bill-dialog-trigger', function () {

                el8.appchart.visitNote.billDialogMgr.show({
                    visitNote: that._model,
                    patient: el8.ptdata.currPatient,
                    source: 'visit note',
                    successCb: function () { that._populateBillingSummary(); }
                });

                return false; // without this, we'll trigger a 'click', which will close the showOnFocus CPT mindreader

            }).on('click', '.print-invoice-trigger', function () {
                var menu = [];
                menu.push({
                    actionText: 'Simple Invoice (no Dx)',
                    actionFn: function () { that._model.printSimplePatientInvoice(); }
                });

                var bill = that._model.getBill();
                if (bill && !bill.hasUnstructuredDxs()) {
                    menu.push({
                        actionText: 'Claims Invoice (ICD-10)',
                        actionFn: function () { that._model.printIcd10PatientInvoice(); }
                    });
                }
                menu.push({
                    actionText: 'Claims Invoice (ICD-9)',
                    actionFn: function () { that._model.printIcd9PatientInvoice(); }
                });

                that._actionsMenu.display($(this), null, { top: -12, left: 36 }, menu);
                return false;

            }).on('click', '.send-bill-early-trigger', function () {
                // User clicked the button that sends a bill to Kareo early
                // (before note was signed off.)
                that._model.sendBillEarly({
                    successCb: function () { that._populateBillingSummary(); }
                });
            }).on('click', '.queue-bill-trigger', function () {
                // even though the bill will be queued automatically when a note is signed,
                // users may want to add a bill to the deferred queue before that happens
                that._model.deferBill({
                    successCb: function () { that._populateBillingSummary(); }
                });

            }).on('click', '.remove-visit-attachment', function () {
                if (that._model.getCurrentEditId()) { return; } // no deletion of attachments on edits
                var $this = $(this);
                var doDelete = function () {
                    var attachmentId = $this.data('id');
                    $.el8_ajax({
                        url: el8.service.urls.get('visitAttachments', [that.getNoteId(), attachmentId]),
                        type: 'DELETE',
                        success: function (data) {
                            that._model.populate(data);
                            that._renderImages();
                        }
                    });
                };
                el8.uiwidget.confirm(
                    'Permanently delete this image?',
                    doDelete,
                    null,
                    {
                        yesBtnText: 'Delete Image',
                        noBtnText: 'Keep Image'
                    }
                );
            }).on('click', '.add-edit-tags-trigger', function () {
                var oldTagIds = that._model.getDocTagIds();
                el8.appchart.dialog.docTags.show({
                    doc: that._model,
                    successCb: function () {
                        var newTagIds = that._model.getDocTagIds();
                        that._populateDocTagsWithTooltips();
                        that._updateBillFromTags(oldTagIds, newTagIds);
                    }
                });
                return false;
            });

            // visit note templatse
            this._container.on('click', '#visit-note-view-templates-trigger', function () {
                el8.appchart.dialog.visitNoteTemplates.show();
            });

            if (el8Globals.FEATURES.MUReports) {
                var that = this;
                this._container.on('change', ':input.transition-type', function (e) {
                    var isReceivingTransition = $(':input[name="receivingTransition"]', that._container).is(':checked');
                    var isReferringTransition = $(':input[name="referringTransition"]', that._container).is(':checked');
                    var typeVal = null;
                    if (isReceivingTransition && isReferringTransition) {
                        typeVal = 'both';
                    } else if (isReceivingTransition) {
                        typeVal = 'receiving';
                    } else if (isReferringTransition) {
                        typeVal = 'referring';
                    }
                    that._model.updateMeaningfulUseInfo({ transition_of_care: typeVal });
                    that.updateMuUi(typeVal);
                });
                this._container.on('change', ':input[name="medsReconciled"]', function (e) {
                    var typeVal = $(this).val();
                    that._model.updateMeaningfulUseInfo({ meds_reconciled: (typeVal * 1 === 1) });
                });
                this._container.on('change', ':input[name="summaryOfCareProvided"]', function (e) {
                    var typeVal = $(this).val();
                    that._model.updateMeaningfulUseInfo({ summary_of_care_provided: (typeVal * 1 === 1) });
                });
                this._container.on('change', ':input[name="currentMedsDocumented"]', function (e) {
                    var typeVal = $(this).val();
                    var map = {
                        'FALSE': false,
                        'TRUE': true,
                        'NA': null
                    };
                    that._model.updateMeaningfulUseInfo({ current_meds_documented: map[typeVal] });

                    if (map[typeVal] === true) {
                        // We resolve the "Medications not documented" CDS if it's showing
                        var cds = el8.data.decisionSupports.getByKey('0419');

                        if (cds) {
                            el8.appchart.visitNote.alertFeed.resolveCdsItem(cds, 'addressed');
                        }
                    }

                    // To help our users out, if this box is checked that meds documented, and doctor has also checked off
                    // the box that this is a transition of care FROM another setting, then we want to mark meds reconciled too
                    if ((map[typeVal] === true) && $(':input[name="receivingTransition"]', that._container).is(':checked')) {
                        that.markMedsReconciled(true);

                        // Same if check box that meds NOT documented, then we want to mark meds NOT reconciled too
                    } else if ((map[typeVal] === false) && $(':input[name="receivingTransition"]', that._container).is(':checked')) {
                        that.markMedsReconciled(false);
                    }
                });
            }

            this._container.on('change', ':input[name="confidential"]', function () {
                var newConfidentiality = that._form.getVal('confidential');
                that._model.saveConfidentiality(newConfidentiality);
            });

            el8.data.visitNoteTypes.bind(EVENTS.LOADED, this._renderVisitTypes);

            $(document).on('el8_noteVitalUpdate', function () {
                if (that._model !== null) { // This event might get triggered right after note is deleted
                    that._renderPreviousVitals();
                }
            });
        },

        _renderVisitTypes: function () {
            if (!that._isOpen) { return; }
            that._noteTypeElt.html(
                el8.template.appchart.visitNote.noteTypeOptions({
                    noteTypes: that._getNoteTypeMaps(),
                    currentlySelected: that._noteTypeElt ? that._noteTypeElt.val() : null
                })
            );
        },
        _getNoteTypeMaps: function () {
            // if our existing note type has been deleted, still include it
            var soyMaps = [];
            var noteTypeId = this._model.getNoteTypeId(this._model.getCurrentEditId());
            var noteType = el8.data.visitNoteTypes.getByIdIncludingDeleted(noteTypeId);

            if (noteType && noteType.isDeleted()) {
                soyMaps.push(noteType.asSoyMap());
            }

            // the deleted type (if one exists) will go on top of the sorted list
            return soyMaps.concat(el8.data.visitNoteTypes.sortedAsSoyMaps());
        },

        isAmendment: function () {
            return Boolean(this._model && this._model.getCurrentEditId());
        },

        _showVitalsSection: function () {
            $('.vitals-container', this._container).show();
            $('.vitals-show-trigger', this._container).hide();
            this._form.getInfoField('bpS_0').getInputField().focusFocus();
        },

        _unloadBlurAll: function () {
            if (this._isOpen) {
                $(':input', this._container).blur();
            }
        },

        /**
         * @param {boolean} opts.isNew - if true, this is showing a newly created
         * visit note as opposed to an existing one
         * @param {string} opts.source - where in the UI this note showing was
         * triggered, e.g. "Nav Bar"
         */
        show: function (note, opts) {

            if (el8Globals['TEASE']) { return; }

            var that = this;

            if (this._isOpen) {
                el8.appservice.notifier.notify('Visit note is already open.');
                return;
            } // Don't show again without hiding first

            this._model = note;
            if (!note.getTemplate()) {
                note.saveTemplate(
                    el8.data.noteSettings.getDefaultVisitNoteTemplate() ||
                    el8.util.consts.DEFAULT_VISIT_NOTE_TEMPLATE);
            }
            this._currTemplate = note.getTemplate();
            // Update reporting year when opening a visit note
            var note_year = this._model.getDocumentDate().year;
            el8.appchart.cqmRefresh.setReportingYear(note_year);

            /**
             * Synchronously fetch CDSs so that they are loaded up
             * when the note is loaded (e.g. current meds box being checked off
             * by form population and therefore 0419 CDS being dismissed)
             */
            el8.data.decisionSupports.softLoad();

            if (!this._isInit) { this._init(); }

            this._isOpen = true;
            this._hasTimers = !el8Globals['FEATURES']['NoVisitNoteTimer'] &&
                (!that._model.getCurrentEditId() && el8.data.currUser.isPhysician());

            // build physician selection list
            var curPhysician = el8.data.practiceUsers.getByStaffId(this._model.getPhysicianId(), true);
            var physicianList = el8.data.practiceUsers.getWithIncluding(
                el8.data.practiceUsers.getPhysicianUsersInWorkspace(),
                {
                    id: curPhysician.getId(),
                    name: curPhysician.getFullName(),
                    staffId: curPhysician.getStaffId()
                }
            );

            // if the note's current physician is disabled, alert the user to implications and expectations
            if (!curPhysician.isActive()) {
                el8.uiwidget.alert("This note is currently assigned to an inactive physician ("
                    + curPhysician.getFullName() + "). Please update the note's physician " +
                    "so it will appear in the correct Unsigned Notes queue.");
            }

            this._container.append(el8.template.appchart.visitNote.form({
                isAmend: Boolean(this._model.getCurrentEditId()),
                noteTypes: this._getNoteTypeMaps(),
                physicians: physicianList,
                visitDate: el8.service.tz.soyStr(el8.service.tz.now())
            }));
            this._content = $('#note-new-visit-content', this._container);

            var $form = $('#note-new-visit-form', this._container);
            this._form = new el8.uiwidget.Form({
                container: $form,
                buttonElt: $('#note-new-visit-buttons', this._container)
            });

            this._actionsMenu = new el8.uiwidget.NewActionsMenu({
                container: this._content,
                anchorTop: $('#note-new-visit-content-scrollable'),
                menuId: 'note-new-visit-actions-menu'
            });

            // All the layout hookups
            el8.appchart.layout.showThirdPane();
            el8.appchart.mgr.thirdpane.bindLayoutListenFn();
            el8.appchart.layout.triggerThreePaneChange(); // Make sure the 3P vs. 2P is setup

            this._initializeTimers();
            this._initializeButtons();

            /**
             * Add form template contents
             */
            $form.html(this.getCurrFormTemplate().formTemplateFn());

            // Set up collapsibility of visit note sections
            $('.section-title', $form).each(function (i, elt) {
                el8.uiwidget.collapsible({
                    container: $(elt).next('.section-body'),
                    triggerElt: $(elt),
                    statusElt: $(elt).find('.section-status'),
                    isCollapsed: false
                });
            });

            this._form.render();
            this._container.show();

            this._bindTimerAutoStartListener();
            if (!this._model.getCurrentEditId()) { this._enableFileUploader(); }

            /**
             * Initialize all sections that we show by default
             */
            this._inputSections = {};
            this._checklists = {};
            this._vitals = {};

            this._visitDateElt = $('#visit-date', this._container);
            this._noteTypeElt = $(':input[name="visitNoteType"]', this._container);
            this._physicianElt = $(':input[name="physicianId"]', this._container);

            this._adjustSize();

            // These need to be added after the form is rendered
            this.getCurrFormTemplate().showFn(this);

            this._initializeVitals();

            /**
             * Remove section we don't want to show
             */
            if (el8Globals['FEATURES']['MUReports']) {
                $('#note-new-visit-print-summary-btn', this._container).hide();
            }

            /**
             * Initialize the alert feed right before prepopulation
             */
            el8.appchart.visitNote.initAlertFeed(this, $('#note-alert-feed-container', this._container));
            el8.appchart.visitNote.refreshAlertFeed(note, false);

            this._prePopulate();

            // Formatting to add class 'noAction' to owned-docs containers
            // when in amend mode, because we don't allow amendments to owned docs
            if (this._model.getCurrentEditId()) {
                $('ul.owned-docs', this._container).addClass('noAction');
            }

            // Set firstFieldSelector for tabbing purposes
            if (this._form.getInfoField('reason')) {
                var name = this._form.getInfoField('reason').getInputField().attr('name');
                this._form.setFirstFieldSelector(':input[name="' + name + '"]');
            }

            // Initialize focus on problem field
            this._form.getInfoField(this.getCurrFormTemplate().focusFieldName)
                .getInputField().focusFocus();

            el8.app.pageLayout.addResizeListener(function () {
                that._adjustSize();
            });

            if (opts && opts.isNew) {
                that._trackStart(opts.source);
            }
        },

        _initializeTimers: function () {
            if (!this._hasTimers) {
                $('#visit-timers', this._container).hide();
                return;
            }

            $('#visit-timers', this._container).show();

            // Because of circular reference with this._syncTimers, defined here to silence linter errors
            // about "... was used before it was defined"
            this._withPatientTimer = null;
            this._documentingTimer = null;
            var timerConfigs = null;

            var stateNameMap = { ended: 0, unpaused: 1, paused: 2 };

            this._switchToDocTimerElt = $('#visit-timer-with-patient .switch-trigger', this._container);
            function updateSwitchTimersElt() {
                if (that._withPatientTimer.getState() === 'unpaused' &&
                    that._documentingTimer.getState() !== 'unpaused') {
                    that._switchToDocTimerElt.show();
                }
                else {
                    that._switchToDocTimerElt.hide();
                }
            }

            this._pauseTimersIfNeeded = function (timer) {
                if (!timer) return;

                if (timer.getState() === 'unpaused') {
                    timerConfigs.forEach(function (otherTimer) {
                        if (otherTimer.timer !== timer) {
                            otherTimer.timer.pauseIfNotEnded();
                        }
                    });
                }
            }

            this._syncTimers = function (timersWithStateChange, async) {
                var changedTimerConfig

                if (!(timersWithStateChange instanceof Array)) {
                    changedTimerConfig = timerConfigs.find(function (timerConfig) {
                        return timerConfig.timer === timersWithStateChange
                    })
                    timersWithStateChange = [timersWithStateChange];
                }


                // Collect current state and time from our timers, but only include state if it has changed,
                // so multiple clients that disagree on state don't clobber each other (see ajax call below).
                var localData = {};
                _.each(timerConfigs, function (config) {
                    localData[config.timeField] = config.timer.getTime();
                    if (_.indexOf(timersWithStateChange, config.timer) >= 0) {
                        localData[config.stateField] = stateNameMap[config.timer.getState()];
                    }
                });

                updateSwitchTimersElt(); // Update before ajax call to avoid flickering

                that._clearAutosaveTimers(); // Reset timeout and prevent multiple overlapping requests
                $.el8_ajax({
                    type: 'POST',
                    url: el8Globals['PATIENT_PATH'] + 'visit-notes/' + that._model.getId() + '/timer/',
                    contentType: 'application/json',
                    data: JSON.stringify(localData),
                    dataType: 'json',
                    async: async !== false,
                    success: function (remoteData) {
                        // Visit note might be closed/gone by the time the ajax response comes back
                        if (!that._model) { return; }

                        // Apply timer state and time from server, which is authoritative and coordinates
                        // among multiple clients (e.g. two browser tabs open on the same visit note)
                        _.each(timerConfigs, function (config) {
                            // Remote time might be a little bit behind due to transmission delays, so we
                            // would lose time if we turn back the timer while it is still running.
                            if (remoteData[config.timeField] > config.timer.getTime() ||
                                remoteData[config.stateField] === 0 ||
                                remoteData[config.stateField] === 2) {
                                config.timer.setTime(remoteData[config.timeField]);
                            }
                            if (remoteData[config.stateField] !== stateNameMap[config.timer.getState()]) {
                                switch (remoteData[config.stateField]) {
                                    case 0:
                                        config.timer.end(true);
                                        break;
                                    case 1:
                                        config.timer.unpause(true);
                                        break;
                                    case 2:
                                        config.timer.pause(true);
                                        break;
                                }
                            }
                        });

                        if (changedTimerConfig && remoteData[changedTimerConfig.stateField] === 1) {
                            // That mean that _syncTimers and ajax success callback was called
                            // after one of the timers changed state.
                            // In that case we want to pause other running timers if needed
                            that._pauseTimersIfNeeded(changedTimerConfig.timer)
                        }

                        updateSwitchTimersElt();

                        // Push to visit note model for rendering in HTML (e.g. visit note preview/sign)
                        that._model.setTimeWithPatient($.secondsToStr(that._withPatientTimer.getTime()));
                        that._model.setTimeDocumenting($.secondsToStr(that._documentingTimer.getTime()));

                        if (remoteData['note_signed']) {
                            that._form.disable();
                            that._disableTimers();
                            el8.uiwidget.alert("This note was updated in another window. Please refresh the page to get the updates.");
                        }
                        else {
                            // Schedule the next _syncTimers()
                            that._setAutosaveTimers();
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status >= 400 && xhr.status < 500) {
                            if (xhr.status === 404) {
                                that._form.disable();
                                that._disableTimers();
                                el8.uiwidget.alert("This note was deleted in another window. Please refresh the page.");
                            }
                            else {
                                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                            }
                        }
                        else if (xhr.status >= 500 && that._model) {
                            // Server error; keep trying in case the server comes back/resolves its problem
                            that._setAutosaveTimers();
                        }
                    }
                });
            };

            this._withPatientTimer = new el8.appchart.visitNote.timer({
                container: $('#visit-timer-with-patient', this._container),
                stateChangedFn: this._syncTimers
            });
            this._documentingTimer = new el8.appchart.visitNote.timer({
                container: $('#visit-timer-documenting', this._container),
                stateChangedFn: this._syncTimers
            });
            timerConfigs = [
                { timer: this._withPatientTimer, timeField: 'time_with_patient', stateField: 'with_patient_timer_state' },
                { timer: this._documentingTimer, timeField: 'time_documenting', stateField: 'documenting_timer_state' }
            ];

            this._switchToDocTimerElt.click(function () {
                that._withPatientTimer.end(true);
                that._documentingTimer.unpause(true);
                that._syncTimers([that._withPatientTimer, that._documentingTimer]);
            });

            this._syncTimers([]);
        },

        _initializeButtons: function () {
            var that = this;
            var saveDraftButtonFn = function () {
                if (!that._model.getCurrentEditId()) {
                    that._trackCompletion('Save as Draft');
                }
                that.close(); // don't call hide()! that doesn't trigger a lastDitchSave
                el8.appservice.notifier.notify('Visit note draft saved.');
            };

            if (el8.data.currUser.isPhysician()) {
                if (this._model.getCurrentEditId()) {
                    this._form.addButton('save', 'Sign Amended Visit Note',
                        function () {
                            return el8.data.practiceSettings.isBillCompletenessCheckEnabled() ? that.validateBill() : that.signNote();
                        }, true);
                } else {
                    this._form.addButton('save', 'Sign Visit Note',
                        function () {
                            return el8.data.practiceSettings.isBillCompletenessCheckEnabled() ? that.validateBill() : that.signNote();
                        }, true);
                }
                this._form.addButton('save-draft', 'Save as Draft & Close',
                    saveDraftButtonFn, false);
                this._form.addButton('preview', 'Preview',
                    function () { return that.previewNote(); }, false);
            } else {
                this._form.addButton('save-draft', 'Save as Draft & Close',
                    saveDraftButtonFn, true);
            }

            this._form.addButton('print', 'Print',
                function () { return that.printNote(); }, false, false, false, true);
            if (this._model.getCurrentEditId()) {
                this._form.addButton('cancel', 'Discard Amendment',
                    function () { return that.cancelAmendNote(); });
            } else {
                this._form.addDiscardButton(function () {
                    // The regular delete behavior when there's no need to coordinate
                    // anything with the scribing dialog
                    var doRegularDelete = function doDelete(onConfirm) {
                        if (that._model.getImages().length) {
                            el8.uiwidget.confirm(
                                'Delete this visit note and the attached images?',
                                function () {
                                    if (onConfirm) {
                                        onConfirm();
                                    }
                                    that.deleteNote(true); // keep images (yesFn)
                                },
                                function () {
                                    if (onConfirm) {
                                        onConfirm();
                                    }
                                    that.deleteNote(); // discard them (noFn)
                                },
                                {
                                    yesBtnText: 'Keep Images, Delete Note',
                                    noBtnText: 'Delete All',
                                    customBtnOpts: { text: 'Cancel' }
                                }
                            );
                        } else {
                            var msg = 'Delete this visit note?';
                            el8.uiwidget.confirm(
                                msg,
                                function () {
                                    if (onConfirm) {
                                        onConfirm();
                                    }
                                    that.deleteNote();
                                }
                            );
                        }
                    }

                    if (el8Globals.FEATURES.AIScribe && el8React.select.isAIScribingDialogOpen()) {
                        if (el8React.select.isAIScribingDialogRecording()) {
                            el8.uiwidget.deleteConfirm(
                                'This action is irreversible and will permanently delete the active recording and the note.',
                                function () {
                                    el8React.dispatch.closeAiScribingDialog();
                                    that.deleteNote(true);
                                },
                                null, // no handler for cancel
                                {
                                    title: 'Scribe Recording Session is in Progress',
                                    msgOverride: true,
                                    yesBtnText: 'Delete Recording & This Note',
                                    noBtnText: 'Cancel'
                                }
                            )
                        } else {
                            doRegularDelete(function onConfirm() {
                                el8React.dispatch.closeAiScribingDialog();
                            });
                        }
                    } else {
                        doRegularDelete();
                    }
                });
            }
        },

        _initializeVitals: function () {
            this._vitalsProcessor = new el8.appchart.visitNote.vitalsProcessor({
                note: this._model,
                form: this._form,
                weightProcessedElt: $('.weight-processed-val', this._container),
                heightProcessedElt: $('.height-processed-val', this._container),
                bmiContainer: $('.bmi', this._container)
            });
            el8.data.visitNoteFormTemplates._initVitals(this);
        },

        _adjustSize: function () {
            this._container.height(this._container.parent().height());
            this._content.height(
                (this._container.outerHeight(true) || 0) -
                ($('#note-new-visit-buttons', this._container).outerHeight(true) || 0) -
                ($('.thirdPaneHeaderContainer', this._container).outerHeight(true) || 0) -
                ($('.thirdPaneFooterContainer', this._container).outerHeight(true) || 0) -
                ($('#note-timers-container', this._container).outerHeight(true) || 0)
            );
        },
        close: function (shouldPauseTimersOption) {
            var shouldPauseTimers = shouldPauseTimersOption === undefined ? true : shouldPauseTimersOption;
            this._lastDitchSave();
            this._saveTimers(shouldPauseTimers, false);

            if (this.getNoteId()) {
                // We don't always keep the client-side model in sync with the server as we go (terrible habit...)
                // This can lead to repopulating the note incorrectly, so we'll make sure to sync up here.
                el8.ptdata.fetch({ fetchId: this.getNoteId(), async: true, force: true });
            }

            this.hide();
            el8.appchart.mainFeeds.reqAct.update();
        },

        hide: function () {
            this._isOpen = false;
            this.reset();
            this._container.empty().hide();
            this._unbindTimerAutoStartListener();
            this._disableFileUploader();

            el8.appchart.visitNote.resetAlertFeed();
            el8.appchart.visitNote.labsProblemsDialog.hide();
            el8.appchart.mgr.notes.clearHighlightResults();

            for (var type in this._checklists) {
                if (this._checklists.hasOwnProperty(type)) {
                    this._checklists[type].destroy();
                }
            }

            // Do all the layout notifications
            el8.appchart.layout.hideThirdPane();
            el8.appchart.mgr.thirdpane.unbindLayoutListenFn();
        },

        reset: function () {
            this._clearAutosaveTimers();

            this._bufferedStartEvent = null;
            this._model = null;
            this._form = null;
            this._inputSections = {};
            this._syncTimers = null;
            threePaneActive = null;
            this._bpCount = 0;
            this._vitalsProcessor.reset();
            this._withPatientTimer = null;
            this._documentingTimer = null;

            this._destroyDocTagTooltips();
        },

        _renderImages: function () {
            var images = this._model.getImages();
            var attachments = this._model.asMapAttachments();

            var imageContainer = $('#note-new-visit-images', this._container);
            imageContainer.html(el8.template.appchart.visitNote.imagesAndAttachments({
                id: this._model.getId(),
                images: images,
                imageIds: this._model.getImageIds(),
                attachments: attachments,
                isAmendment: this.isAmendment()
            }));

            if (images.length) {
                $('.visit-images-loading', imageContainer).fadeOut('slow');
                el8.util.feed.loadImages({
                    item: this._model,
                    images: images,
                    container: imageContainer,
                    width: '100%',
                    zoomable: false
                });
            }
        },

        _prePopulate: function () {

            this._renderImages();
            var noteTypeId = this._model.getNoteTypeId(this._model.getCurrentEditId());
            if (noteTypeId) {
                this._noteTypeElt.val(noteTypeId);
                if (parseInt(this._noteTypeElt.val(), 10) !== noteTypeId) {
                    // this happens if noteTypeId is no longer a valid noteType
                    // (i.e., it's been deleted); it will trigger a save
                    this._noteTypeElt.change();
                }
            } else {
                var defaultNoteType = el8.data.visitNoteTypes.sorted()[0];
                if (defaultNoteType) {
                    this._noteTypeElt.val(defaultNoteType.getId());
                }
            }
            this._physicianElt.val(this._model.getPhysicianId());
            this.updateVisitDateElt();

            // Prepopulate vitals
            this._populateBp();
            this._populateVitals('hr', this._model.getSingletonVital('hr', this._model.getCurrentEditId()));
            this._populateVitals('rr', this._model.getSingletonVital('rr', this._model.getCurrentEditId()));
            this._populateVitals('temperature', this._model.getSingletonVital('temperature', this._model.getCurrentEditId()));
            this._populateVitals('height', this._model.getSingletonVital('height', this._model.getCurrentEditId()));
            this._populateVitals('weight', this._model.getSingletonVital('weight', this._model.getCurrentEditId())); // needs to come after height
            this._populateVitals('oxygen', this._model.getSingletonVital('oxygen', this._model.getCurrentEditId()));
            this._populateVitals('hc', this._model.getSingletonVital('hc', this._model.getCurrentEditId()));
            this._populateVitals('pain', this._model.getSingletonVital('pain', this._model.getCurrentEditId()));
            if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) { this._populateCustomObservations(); }

            el8.data.visitNoteSectionNames.forEach(function (sectionName) {
                that._populateInputSection(sectionName.toLowerCase());
            });

            this._updatePreviousVitals();
            this._populateMeaningfulUseSection();
            this._populateDocTagsWithTooltips();
            this._populateConfidentiality();
        },

        _populateDocTagsWithTooltips: function () {
            var docTagMaps = this._model.getDocTagMaps();
            if (docTagMaps) {
                $('.doctags', this._container).html(
                    el8.template.appshared.docTags.docTagsLine({
                        docTags: this._model.getDocTagMaps()
                    })
                );

                el8.appshared.docTags.tooltips.create(this._container, this._model);
            }
        },

        _populateConfidentiality: function () {
            that._form.setVal('confidential', this._model.isConfidential(), true);
        },

        _destroyDocTagTooltips: function () {
            _(this._container.find('.doctag-coded.has-tippy')).each(function (span) {
                el8.appshared.docTags.tooltips.destroy(span);
            });
        },

        _populateInputSection: function (name) {
            var items = this._model.getBulletSets()[name.capitalize()].sorted(this._model.getCurrentEditId());
            if (items.length) {
                this._inputSections[name].addEntries(items);
            }
            // Also check to see if there are checklists to prepopulate
            if (name === 'pe') {
                var currentPeDetail = this._model.getChecklists('pe', this._model.getCurrentEditId()).current;
                if (currentPeDetail && !currentPeDetail.isEmpty()) {
                    if (!this._checklists['pe']) { this._addInputSection('pe'); }
                    this._checklists['pe'].populate(currentPeDetail, false);
                    this._inputSections['pe'].show();
                }
            } else if (name === 'ros') {
                var currentRosDetail = this._model.getChecklists('ros', this._model.getCurrentEditId()).current;
                if (currentRosDetail && !currentRosDetail.isEmpty()) {
                    if (!this._checklists['ros']) { this._addInputSection('ros'); }
                    this._checklists['ros'].populate(currentRosDetail, false);
                    this._inputSections['ros'].show();
                }
            }
        },

        // See https://github.com/elationemr/hippo/pull/9871/files#r784478897
        _populateBillingSummary: function (updatedNoteIdOrSomethingElse) {
            if (!this._model) { return; }
            var bill = this._model.getBill();
            if (updatedNoteIdOrSomethingElse != null) {
                var visitNote = el8.ptdata.visitNotes.getById(updatedNoteIdOrSomethingElse);
                if (visitNote != null) {
                    bill = visitNote.getBill();
                    this._model.setBill(bill);
                }
            }
            $('.billing-summary', this._container).html(
                el8.template.appchart.visitNote.billSummary({
                    bill: bill ? bill.asSoyMap() : null,
                    patient: el8.ptdata.currPatient.asSoyMap(),
                    isInvoicingEnabled: el8.data.practiceSettings.isInvoicingEnabled(),
                    isPMSIntegrated: el8.data.currPractice.isPMSIntegrated(),
                    isDeferredBillsEnabled: el8.data.practiceSettings.isDeferredBillsEnabled(),
                    billNotesWordsArray: bill ? el8.util.string.getWordObjArray(bill.getNotes()) : [],
                    isVisitNoteSendBillToPmsEnabled: el8.data.practiceSettings.isVisitNoteSendBillToPmsEnabled(),
                })
            );
        },

        _populateMeaningfulUseSection: function () {
            var transitionType = this._model.getMeaningfulUseInfoItem('getTransitionOfCare');
            this._doPopulateMUTransitionCareSection(transitionType);
            var currMedsDocumented = this._model.getMeaningfulUseInfoItem('isCurrentMedsDocumented');
            this._doPopulateMUCurrentMedsSection(currMedsDocumented);
        },

        _doPopulateMUTransitionCareSection: function (type) {
            if ((type === 'both') || (type === 'referring')) {
                $(':input[name="referringTransition"]', this._container).prop('checked', true);
            }
            if ((type === 'both') || (type === 'receiving')) {
                $(':input[name="receivingTransition"]', this._container).prop('checked', true);
            }
            if (type) {
                this.updateMuUi(type);
            }
        },

        _doPopulateMUCurrentMedsSection: function (val) {
            if (val === true) {
                $(':input[name="currentMedsDocumented"][value="TRUE"]', this._container).prop('checked', true);
            } else if (val === false) {
                $(':input[name="currentMedsDocumented"][value="FALSE"]', this._container).prop('checked', true);
            } else {
                // If selection hasn't explicitly been made, do a soft try to check for whether any meds
                // have been documented today. I say "soft" because it could be that there is a temporary non-Rx
                // that isn't yet in the MedOrder cache (temporary doc meds don't come down in ref panel fetch).
                // At same time, this behavior will be consistent with the box being checked if anything new is
                // on LHS
                var anyMedSignedToday = _.find(el8.ptdata.medOrders.all(),
                    function (o) { return o.getSignDate() && el8.util.datecompare.isToday(o.getSignDate()); });
                if (anyMedSignedToday) {
                    $(
                        ':input[name="currentMedsDocumented"][value="TRUE"]',
                        this._container
                    )
                        .prop("checked", true)
                        .trigger("change");
                } else {
                    $(':input[name="currentMedsDocumented"][value="FALSE"]', this._container).prop('checked', true);
                }
            }
        },

        _populateBp: function () {
            var bps = this._model.getVitalsSets()['bp'].sorted(this._model.getCurrentEditId());
            if (bps.length > 1) {
                this._populateVitals('bp_0', bps[0]);
                for (var i = 1; i < bps.length; i++) {
                    this._addBpInput(bps[i]);
                }
            } else {
                this._populateVitals('bp_0', this._model.getSingletonVital('bp', this._model.getCurrentEditId()));
            }
        },

        _populateVitals: function (name, vitalItem) {
            if (!this._vitals[name]) { return; }
            var addedVal = this._vitals[name].populate(vitalItem);
            if (name === 'height') { this._vitalsProcessor.processHeightInput(true); }
            if (name === 'weight') { this._vitalsProcessor.processWeightInput(); }
            if (addedVal) { this._showVitalsSection(); }
        },

        _populateCustomObservations: function () {
            var that = this;
            el8.util.consts.ADDITIONAL_VITALS.forEach(function (customVital) {
                if (!that._vitals[customVital]) { return; }
                var vitalItem = that._model.getSingletonVital(customVital, that._model.getCurrentEditId());
                var addedVal = that._vitals[customVital].populate(vitalItem);
                if (addedVal) { that._showVitalsSection(); }
            });
        },

        _updatePreviousVitals: function () {
            if (el8.util.isEmptyObj(this._vitals)) { return; }
            var that = this;

            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('previousCustomObservations', [that._model.getIdForUrl()]),
                success: function (data) {
                    if (data && data.length) {

                        var map = {};
                        data.forEach(function (observation) {
                            map[observation.observation_name] = observation;
                        });
                        // stores stuff like:
                        //  {
                        //      bodyfat: { observation_name: 'bodyfat', previous_value: '20', previous_time: ...},
                        //      dlm: ...
                        //  }
                        that._vitalsProcessor.setPreviousCustomObservations(map);
                    }

                    // This always gets called, because we need to render
                    // previous weight/bmi even if there aren't customs
                    that._renderPreviousVitals();
                }
            });

            // previousHeight isn't actually displayed to the user (or stored on the model);
            // it's just set in the background to make the BMI calculation work
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('visitPreviousHeight', [that._model.getIdForUrl()]),
                success: function (data) {
                    if (data) {
                        that._vitalsProcessor.setPreviousHeight(data['height']);
                        that._vitalsProcessor.processHeightInput(true);
                        that._vitalsProcessor.processWeightInput();
                    }
                }
            });
        },

        _renderPreviousVitals: function () {
            if (el8.util.isEmptyObj(this._vitals)) { return; }

            var previousWeight = this._model.getPreviousWeight(this._model.getCurrentEditId());
            var previousBmi = this._model.getPreviousBmi(this._model.getCurrentEditId());
            var previousTime = this._model.getPreviousTime(this._model.getCurrentEditId());
            if (previousWeight) {
                $('.previous-weight', this._container).html(
                    el8.template.appchart.visitNote.previousVital({
                        val: previousWeight,
                        delta: this._model.getWeightDelta(),
                        date: el8.service.tz.soyStr(previousTime),
                        units: 'lbs'
                    })
                );
            }
            if (previousBmi) {
                $('.previous-bmi', this._container).html(
                    el8.template.appchart.visitNote.previousVital({
                        val: previousBmi,
                        delta: this._model.getBmiDelta(),
                        date: el8.service.tz.soyStr(previousTime)
                    })
                );
            }

            if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) {
                // We assume the data on previous vitals has already been fetched
                // by the AJAX call in updatePreviousVitals and then render
                // based on what's in the current vital, if one is saved,
                // or that AJAX data if we don't have an observation recorded yet.
                var previousCustoms = this._vitalsProcessor.getPreviousCustomObservations();
                _.values(previousCustoms).forEach(function (observation) {
                    var name = observation.observation_name;
                    var vitalItem = that._model.getSingletonVital(name, that._model.getCurrentEditId());

                    if (vitalItem && vitalItem.getPreviousValue()) {
                        $('.previous-' + name, that._container).html(
                            el8.template.appchart.visitNote.previousVital({
                                val: vitalItem.getPreviousValue(),
                                delta: vitalItem.getDelta(),
                                date: el8.service.tz.soyStr(vitalItem.getPreviousTime())
                            })
                        );
                    } else {
                        $('.previous-' + name, that._container).html(
                            el8.template.appchart.visitNote.previousVital({
                                val: observation.previous_value,
                                date: observation.previous_time
                            })
                        );
                    }
                });
            }
        },

        _getVisitNote: function (isOnHold) {
            this._model.setOnHold((isOnHold === true)); // default false
        },

        _bindTimerAutoStartListener: function () {
            var that = this;
            this._keyListenFn = _.debounce(function (event) {
                // Intelligently start/stop timers
                if (that._hasTimers && that._form.isEnabled()) {
                    var timers = [that._withPatientTimer, that._documentingTimer];
                    var timersWithStateChange = _.filter(timers, function (t) { return t.unpauseIfNotEnded(true); });
                    if (timersWithStateChange.length > 0) {
                        that._syncTimers(timersWithStateChange);
                    }
                }
            }, 1000, true);
            // debounce because we really only need to check once, when the keydowns start
            $(document).on('keydown', that._keyListenFn);
        },

        _unbindTimerAutoStartListener: function () {
            var that = this;
            if (that._keyListenFn) {
                $(document).unbind('keydown', that._keyListenFn);
            }
        },

        _enableFileUploader: function () {
            this._fileUploader = new el8.uiwidget.FileUploader({
                container: this._container,
                isImageUpload: true,
                singleFile: true,
                droppableArea: this._container,
                droppableZoneClass: 'el8UploadDroppableOverlay',
                inputWidth: 0,
                inputHeight: 0,
                onUploadMessage: 'Processing file... Please do not delete from your computer until it completes.',
                customUploadFn: function (files) {
                    var fd = new FormData();
                    fd.append('file', files[0]);
                    $.el8_longPoll({
                        url: el8.service.urls.get('visitAttachments', [that.getNoteId()]),
                        data: fd,
                        isFileUpload: true,
                        success: function (data) {
                            if (!that._model) { return; }
                            el8.appservice.notifier.notify('Attachments added to visit note.');
                            that._model.populate(data);
                            that._renderImages();
                        },
                        error: function (data) {
                            el8.appservice.notifier.clear();
                        }
                    });
                }
            });
            this._fileUploader.show();
            el8.appchart.mainFeeds.chartFileUploader.hide();
        },

        _disableFileUploader: function () {
            if (!this._fileUploader) { return; }
            el8.appchart.mainFeeds.chartFileUploader.show();
            this._fileUploader.hide();
            this._fileUploader = null;
        },

        _disableTimers: function () {
            if (this._hasTimers) {
                this._withPatientTimer.hideButtons();
                this._documentingTimer.hideButtons();
            }
        },

        /**
         * Save!
         */
        _lastDitchSave: function () {

            if (!this._isOpen) { return; }

            // Always do last ditch save of BMI
            if (this._vitalsProcessor && this._vitalsProcessor.getIsBMIDirty()) {
                this._vitalsProcessor.saveBMI();
            }

            // Do last ditch SYNC save to make sure everything
            // for sure for sure gets saved
            for (var name in this._inputSections) {
                if (this._inputSections.hasOwnProperty(name)) {
                    this._inputSections[name].saveIfDirty();
                }
            }
            for (var name in this._checklists) {
                if (this._checklists.hasOwnProperty(name)) {
                    this._checklists[name].saveIfDirty();
                }
            }
            for (var name in this._vitals) {
                if (this._vitals.hasOwnProperty(name)) {
                    this._vitals[name].saveIfDirty();
                }
            }
        },
        /**
         * Checks if a bill exists or not
         * @param {*} bill
         * @returns {boolean}
         */
        doesBillExist: function (bill) {
            return bill != null;
        },
        /**
         * Checks the bill for any service lines that are missing CPT codes (empty strings) including the first row
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        isBillMissingCptCodes: function (bill, helper) {
            if (helper.doesBillExist(bill)) {
                var cptCodes = bill.getCpts();
                return cptCodes.some(function (code) {
                    return code.getCpt() === '';
                });
            }
            return false;
        },
        /**
         * Checks if the bill has any CPT codes
         * Regardless of how many service lines there are on the bill, will return true if there are no CPT codes
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        hasNoCptCodesInBill: function (bill, helper) {
            if (helper.doesBillExist(bill)) {
                var cptCodes = bill.getCpts();
                return cptCodes.every(function (code) {
                    return code.getCpt() === '';
                });
            }
            return false;
        },
        /**
         * Checks the bill to see if any dxCodes have been entered
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        hasActualDxCodeInBill: function (bill, helper) {
            if (helper.doesBillExist(bill)) {
                var cptCodes = bill.getCpts();
                return cptCodes.some(function (code) {
                    return code.getDxs().length > 0;
                });
            }
            return false;
        },
        /**
         * Checks the bill to see if any bill service lines are missing DX codes
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        isBillMissingDxCodes: function (bill, helper) {
            if (helper.doesBillExist(bill)) {
                 var cptCodes = bill.getCpts();
                 return cptCodes.some(function(code) {
                    return code.getDxs().length === 0;
                 });
            }
            return false;
        },
        /**
         * Checks if the bill is missing both CPT and DX codes (is empty)
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        isBillMissingCptDxCodes: function (bill, helper) {
            if (helper.doesBillExist(bill) && helper.hasNoCptCodesInBill(bill, helper) && !helper.hasActualDxCodeInBill(bill, helper)) {
                return true;
            }
            return false;
        },
        /**
         * Checks if the bill is missing a Service Location
         * @param {*} bill
         * @param {*} helper
         * @returns {boolean}
         */
        isBillMissingServiceLocation: function (bill, helper) {
            if (helper.doesBillExist(bill) && !bill.getServiceLocationId()) {
                return true;
            }
            return false;
       },
        /**
         * Helper to return an object of all the triggered alerts and their associated alert levels
         * Filters out any triggered alerts with an alert level set to 'none'
         * @param {*} bill
         * @param {*} helper
         * @returns {Object}
         */
        getTriggeredAlerts: function (bill, helper) {
            var triggeredAlerts = {};

            // Checks if the bill is missing CPT AND DX codes OR if no bill exists at all
            if ((!helper.doesBillExist(bill) && !helper.hasNoCptCodesInBill(bill, helper) && !helper.hasActualDxCodeInBill(bill, helper)) || helper.isBillMissingCptDxCodes(bill, helper)) {
                triggeredAlerts.missingCptDxCodes = el8.data.practiceSettings.getBillCompletenessMissingCptDxCodesAlertPreference();
            }
            // If the bill doesn't exist then we still want to surface a message to the user that there is no service location set
            // This follows the pattern of displaying the `missingCptDxCodes` message when the bill doesn't exist (see condition above)
            if (!helper.doesBillExist(bill)) {
                triggeredAlerts.missingServiceLocation = el8.data.practiceSettings.getBillCompletenessMissingServLocAlertPreference();
            }
            // Checks if the bill is missing CPT codes
            if (helper.isBillMissingCptCodes(bill, helper)) {
                triggeredAlerts.missingCptCodes = el8.data.practiceSettings.getBillCompletenessMissingCptCodesAlertPreference();
            }
            // Checks if the bill is missing DX codes
            if (helper.isBillMissingDxCodes(bill, helper)) {
                triggeredAlerts.missingDxCodes = el8.data.practiceSettings.getBillCompletenessMissingDxCodesAlertPreference();
            }
            // Checks if the bill is missing a Service Location
            if (helper.isBillMissingServiceLocation(bill, helper)) {
                triggeredAlerts.missingServiceLocation = el8.data.practiceSettings.getBillCompletenessMissingServLocAlertPreference();
            }

            // Loops over the triggereAlerts object and deletes any alerts that have a value of 1 (aka 'none', no alert)
            for (var alert in triggeredAlerts) {
                if (triggeredAlerts[alert] === 1) {
                    delete triggeredAlerts[alert];
                }
            }

            return triggeredAlerts;
        },
        /**
         * Opens the bill confirmation popup to validate a visit note before it's sent
         * @param {str} dialogMessage Prepended onto the dialogFollowupMessage that becomes the finalDialogMessage
         * @param {str} hardDialogFollowupMessage Message that is used for hard stop validations (aka "Blocker"). Appended onto the dialogMessage.
         * @param {str} softDialogFollowupMessage Message that is used for soft stop validations (aka "Reminder"). Appended onto the dialogMessage.
         * @param {number} billCompletenessAlertingPreference Parameter that should be either 1 ('none'), 2 ('soft'), or 3 ('hard') which will decide what this dialog looks like
         */
        openBillConfirmationPopup: function (dialogIntroMessage, dialogMessage, hardDialogFollowupMessage, softDialogFollowupMessage, billCompletenessAlertingPreference) {
            var amplitudeEventBody = {
                'patient id': el8.ptdata.currPatient.getId(),
                'practice id': el8.data.currPractice.getId(),
                'alert type': billCompletenessAlertingPreference,
            };

            // FUTURE: Add to amplitude taxonomy confluence
            el8.util.amplitude.logEvent('open bill completeness confirmation dialog', amplitudeEventBody);

            var finalDialogMessage;
            if (billCompletenessAlertingPreference === el8.util.consts.BILL_COMPLETENESS_ALERT_PREFERENCES.hard) { // hard
                finalDialogMessage = dialogIntroMessage + dialogMessage + '\n\n' + hardDialogFollowupMessage;
                el8.uiwidget.confirm(
                    finalDialogMessage,
                    function () {
                        el8.util.amplitude.logEvent(
                            'opt to add billing info',
                            $.extend(amplitudeEventBody, { 'source': 'bill completeness confirmation dialog' })
                        );
                        el8.appchart.visitNote.billDialogMgr.show({
                            visitNote: that._model,
                            patient: el8.ptdata.currPatient,
                            source: 'visit note',
                            successCb: function () { that._populateBillingSummary(); }
                        });
                    },
                    function () {
                        el8.util.amplitude.logEvent(
                            'cancel out of dialog',
                            $.extend(amplitudeEventBody, { 'source': 'bill completeness confirmation dialog' })
                        );
                    },
                    {
                        title: 'Billing information needed before sign-off',
                        yesBtnText: 'Add Billing Information',
                        noBtnText: 'Cancel',
                        prefWidth: 630,
                    }
                );
            } else if (billCompletenessAlertingPreference === el8.util.consts.BILL_COMPLETENESS_ALERT_PREFERENCES.soft) { // soft
                finalDialogMessage = dialogIntroMessage + dialogMessage + '\n\n' + softDialogFollowupMessage;
                el8.uiwidget.confirm(
                    finalDialogMessage,
                    function () {
                        el8.util.amplitude.logEvent(
                            'opt to add billing info',
                            $.extend(amplitudeEventBody, { 'source': 'bill completeness confirmation dialog' })
                        );
                        el8.appchart.visitNote.billDialogMgr.show({
                            visitNote: that._model,
                            patient: el8.ptdata.currPatient,
                            source: 'visit note',
                            successCb: function () { that._populateBillingSummary(); }
                        });
                    },
                    function () {
                        el8.util.amplitude.logEvent(
                            'sign incomplete bill anyway',
                            $.extend(amplitudeEventBody, { 'source': 'bill completeness confirmation dialog' })
                        );
                        that.signNote();
                    },
                    {
                        title: 'Sign without billing information?',
                        yesBtnText: 'Add Billing Information',
                        noBtnText: 'Sign Anyway',
                        prefWidth: 630,
                    }
                );
            }
        },
        validateBill: function () {
            var that = this;
            var bill = that._model.getBill();

            var triggeredAlerts = that.getTriggeredAlerts(bill, that);

            // Useful logging that may be used in the future to help debug things
            /*
            console.log('doesBillExist', that.doesBillExist(bill, that));
            console.log('hasNoCptCodesInBill', that.hasNoCptCodesInBill(bill, that));
            console.log('isBillMissingCptCodes', that.isBillMissingCptCodes(bill, that));
            console.log('hasActualDxCodeInBill', that.hasActualDxCodeInBill(bill, that));
            */

            // Default dialog messages that can be changed on a case by case basis
            var dialogIntroMessage = 'The bill for this visit note has the following issue(s):';
            var hardDialogFollowupMessage = 'To sign off on this note, you must address these issues.';
            var softDialogFollowupMessage = 'Sending incomplete bills to your billing system may cause errors or prevent reimbursement from insurance.';
            var missingCptDxCodesMessage = '\n  - There are no procedure or diagnosis codes on the bill';
            var missingCptCodesMessage = '\n  - One or more lines have no procedure codes';
            var missingDxCodesMessage = '\n  - One or more lines have no diagnosis codes';
            var missingServiceLocationMessage = '\n  - There is no service location on the bill';

            // Scenario 1: If no alerts are triggered then exit early and sign the note
            if (_.isEmpty(triggeredAlerts)) {
                that.signNote();
                return;
            }

            // Billing Guidance alert scenarios - looped through and added to `triggeredAlerts` if criteria are met
            // NOTE: the bill warning dialog will be triggered for the first `condition` that is truthy
            // It's important that each of these scenarios are mutually exclusive
            // If more than one scenario's `condition`s are truthy then the bill warning dialog will be triggered for the first truthy `condition` it finds
            var alertScenarios = [
                // Scenario 2: Bill does not exist for a visit note OR bill exists but is empty (no CPT or DX codes) AND is missing a service location
                {
                    condition: triggeredAlerts.missingCptDxCodes && triggeredAlerts.missingServiceLocation,
                    message: missingCptDxCodesMessage + missingServiceLocationMessage,
                    severity: Math.max(triggeredAlerts.missingCptDxCodes, triggeredAlerts.missingServiceLocation)
                },
                // Scenario 3: Bill does not exist for visit note OR bill exists but is empty (no CPT or DX codes)
                {
                    condition: triggeredAlerts.missingCptDxCodes && !triggeredAlerts.missingServiceLocation,
                    message: missingCptDxCodesMessage,
                    severity: triggeredAlerts.missingCptDxCodes
                },
                // Scenario 4: Bill has one or more lines that are missing CPT codes
                {
                    condition: triggeredAlerts.missingCptCodes && !triggeredAlerts.missingDxCodes && !triggeredAlerts.missingServiceLocation,
                    message: missingCptCodesMessage,
                    severity: triggeredAlerts.missingCptCodes
                },
                // Scenario 5: Bill has one or more lines that are missing CPT codes AND is missing a service location
                {
                    condition: triggeredAlerts.missingCptCodes && triggeredAlerts.missingServiceLocation && !triggeredAlerts.missingDxCodes,
                    message: missingCptCodesMessage + missingServiceLocationMessage,
                    severity: Math.max(triggeredAlerts.missingCptCodes, triggeredAlerts.missingServiceLocation)
                },
                // Scenario 6: Bill has one or more lines that are missing DX codes
                {
                    condition: triggeredAlerts.missingDxCodes && !triggeredAlerts.missingCptCodes && !triggeredAlerts.missingServiceLocation,
                    message: missingDxCodesMessage,
                    severity: triggeredAlerts.missingDxCodes
                },
                // Scenario 7: Bill has one or more lines that are missing DX codes AND is missing a service location
                {
                    condition: triggeredAlerts.missingDxCodes && triggeredAlerts.missingServiceLocation && !triggeredAlerts.missingCptCodes,
                    message: missingDxCodesMessage + missingServiceLocationMessage,
                    severity: Math.max(triggeredAlerts.missingDxCodes, triggeredAlerts.missingServiceLocationMessage)
                },
                // Scenario 8: Bill has one or more lines that are missing CPT codes AND one or more lines that are missing DX codes
                {
                    condition: triggeredAlerts.missingCptCodes && triggeredAlerts.missingDxCodes && !triggeredAlerts.missingServiceLocation,
                    message: missingCptCodesMessage + missingDxCodesMessage,
                    severity: Math.max(triggeredAlerts.missingCptCodes, triggeredAlerts.missingDxCodes)
                },
                // Scenario 9: Bill has one or more lines that are missing CPT codes AND one or more lines that are missing DX codes
                // AND is missing a service location
                {
                    condition: triggeredAlerts.missingCptCodes && triggeredAlerts.missingDxCodes && triggeredAlerts.missingServiceLocation,
                    message: missingCptCodesMessage + missingDxCodesMessage + missingServiceLocationMessage,
                    severity: Math.max(triggeredAlerts.missingCptCodes, triggeredAlerts.missingDxCodes, triggeredAlerts.missingServiceLocation)
                },
                // Scenario 10: Bill is missing a service Location
                // Is triggered when a bill exists but there is not service location assigned
                {
                    condition:triggeredAlerts.missingServiceLocation,
                    message: missingServiceLocationMessage,
                    severity: triggeredAlerts.missingServiceLocation
                },
            ];

            // loop through `alertScenarios` and trigger the bill warning confirmation dialog to display if a `condition === true`
            for (var scenario in alertScenarios) {
                if (alertScenarios[scenario].condition) {
                    that.openBillConfirmationPopup(
                       dialogIntroMessage,
                       alertScenarios[scenario].message,
                       hardDialogFollowupMessage,
                       softDialogFollowupMessage,
                       alertScenarios[scenario].severity
                   );
                    return;
                }
            }
            // Sign visit note if none of the above scenarios are met (failsafe)
            that.signNote();
        },
        signNote: function () {
            var that = this;

            if (!this._model.getCurrentEditId()) {
                this._trackCompletion('Sign');
            }

            that._form.disable();
            that._lastDitchSave();
            this._saveTimers(true, true);
            that._model.sign(function () {
                that._form.enable();
                that.hide();
            });
        },
        previewNote: function () {

            this._lastDitchSave();
            this._saveTimers(true, true);

            var that = this;
            // Go get a full refresh from the server before previewing
            $.el8_ajax({
                url: el8.service.urls.get('previewVisitNote', [that._model.getIdForUrl()]),
                type: 'POST',
                async: false,
                success: function (data) {
                    that._model.populate(data);
                    that._model.setPreview(true);
                    if (!that._model.getCurrentEditId()) {
                        el8.ptdata.visitNotes.addOrUpdate(that._model, true);
                    } else {
                        el8.ptdata.tempVisitNotes.addOrUpdate(that._model, true);
                    }

                    /* We need to store a reference to that._model, since it gets
                     * destroyed with that.hide() */
                    var note = that._model;

                    /* We want to hide first so that the chart feed is visible
                     * when the preview is added. Otherwise scrolling doesn't work
                     * properly */
                    that.hide();

                    /* Do the preview magic */
                    el8.appchart.mainFeeds.chart.addPreview(note);
                    $('#preview_' + el8.appchart.mainFeeds.chart.getFeedId(note.getId()))
                        .find('.cardDetails').addClass('watermarkPreview');
                    el8.appservice.notifier.notify(
                        note.getNotifyText('SAVE_PREVIEW'));
                }
            });
        },
        cancelAmendNote: function () {
            var that = this;
            that._form.disable();
            el8.appservice.notifier.notify('Canceling visit note amendment...');
            var msg = 'Canceling will discard this visit note amendment. Proceed?';
            el8.uiwidget.confirm(
                msg,
                function () {
                    $.el8_ajax({
                        type: 'DELETE',
                        url: el8Globals['PATIENT_PATH'] + 'visit-notes/' + that._model.getIdForUrl() + '/',
                        success: function () {
                            el8.appchart.mainFeeds.reqAct.update();
                            el8.appservice.notifier.notify('Visit note amendment cancelled.');
                            that._model.setCurrentEditId(null);
                            // We want to go refetch this entire model
                            el8.ptdata.fetch({ 'model_class': 'VisitNote', 'id': that._model.getId() }, true);
                            that._form.enable();
                            that.hide();
                        }
                    });
                },
                function () {
                    that._form.enable();
                }
            );
        },
        deleteNote: function (refileImages) {
            var that = this;
            if (!this._model.getCurrentEditId()) {
                this._trackCompletion('Discard');
            }
            that._form.disable();
            el8.appservice.notifier.notify(
                that._model.getNotifyText('DELETE_IN_PROGRESS'));
            var successCb = function (item) {
                var notifyText = (refileImages) ?
                    that._model.getNotifyText('DELETE_COMPLETE_IMAGES_REFILED') :
                    that._model.getNotifyText('DELETE_COMPLETE');
                el8.appservice.notifier.notify(notifyText);
                el8.appchart.mainFeeds.reqAct.update();
                that._form.enable();
                that.hide();
            };
            if (refileImages) {
                el8.ptdata.visitNotes.deleteItemSendBackImages(that._model, true, {
                    successCb: successCb,
                    errorCb: function () {
                        that._form.disable();
                    },
                    error_msg: "This note was updated in another window. Please refresh the page to get the updates."
                });
            } else {
                el8.ptdata.visitNotes.deleteItem(that._model, true, {
                    successCb: successCb,
                    errorCb: function () {
                        that._form.disable();
                    },
                    error_msg: "This note was updated in another window. Please refresh the page to get the updates."
                });
            }
        },
        printNote: function () {
            if (this._model) {
                this._model.printNote(false);
            }
        },
        printPatientSummary: function () {
            if (this._model) {
                this._model.printPatientSummary();
                this.addText('Patient summary printed', 'tx');
            }
        },
        printClinicalSummary: function () {
            if (this._model) {
                this.markNoteSummaryProvided(true);
                this.markSummaryOfCareProvided(true);
                this._model.printClinicalSummary();
                this.addText('Clinical summary (MIPS) printed', 'tx');
            }
        },
        markMedsReconciled: function (val) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ meds_reconciled: val });
            }
            if (el8Globals['FEATURES']['MUReports']) {
                if (val) {
                    $(':input[name="medsReconciled"][value="1"]', this._container).prop('checked', true);
                } else {
                    $(':input[name="medsReconciled"][value="0"]', this._container).prop('checked', true);
                }
            }
        },
        markSummaryOfCareProvided: function (val) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ summary_of_care_provided: val });
            }
            if (el8Globals['FEATURES']['MUReports']) {
                if (val) {
                    $(':input[name="summaryOfCareProvided"][value="1"]', this._container).prop('checked', true);
                } else {
                    $(':input[name="summaryOfCareProvided"][value="0"]', this._container).prop('checked', true);
                }
            }
        },
        markNoteSummaryProvided: function (val) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ note_summary_provided: val });
            }
        },
        markTransitionOfCareType: function (type) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ transition_of_care: type });
            }
            if (el8Globals['FEATURES']['MUReports']) {
                this._doPopulateMUTransitionCareSection(type);
            }
        },
        markHandoutGiven: function (val) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ handout_given: val });
            }
        },
        markCurrentMedsDocumented: function (val) {
            if (this._model) {
                this._model.updateMeaningfulUseInfo({ current_meds_documented: val });
            }
            if (el8Globals['FEATURES']['MUReports']) {
                this._doPopulateMUCurrentMedsSection(val);
            }
        },
        updateMuUi: function (selectedType) {
            $('.mu-toc', this._container).hide();
            if (selectedType === 'receiving' || selectedType === 'both') {
                $('#mu-toc-receiving', this._container).show();
                this._content.scrollTo('100%');
                // Populate available value
                $(':input[name="medsReconciled"][value="' + (this._model.getMeaningfulUseInfoItem('isMedsReconciled') ? '1' : '0') +
                    '"]', this._container).prop('checked', true);

            }
            if (selectedType === 'referring' || selectedType === 'both') {
                $('#mu-toc-referring', this._container).show();
                this._content.scrollTo('100%');
                // Populate available value
                $(':input[name="summaryOfCareProvided"][value="' + (this._model.getMeaningfulUseInfoItem('isSummaryOfCareProvided') ? '1' : '0') +
                    '"]', this._container).prop('checked', true);
            }
        },
        _setAutosaveTimers: function () {
            this._clearAutosaveTimers();
            this._saveTimersTimeoutId = $.el8_setTimeout(this._syncTimers, 1000 * 60 * 15);
        },
        _clearAutosaveTimers: function () {
            if (this._saveTimersTimeoutId) {
                $.el8_clearTimeout(this._saveTimersTimeoutId);
            }
        },
        _saveTimers: function (pauseTimers, blocking) {
            // This function might be called prior to _initializeTimers(), e.g.
            // triggered by page unload, at which point _syncTimers has not yet
            // been defined.
            if (this._hasTimers && this._syncTimers) {
                if (pauseTimers) {
                    this._withPatientTimer.pauseIfNotEnded(true);
                    this._documentingTimer.pauseIfNotEnded(true);
                    this._syncTimers([this._withPatientTimer, this._documentingTimer], blocking !== true);
                }
                else {
                    this._syncTimers([], blocking !== true);
                }
            }
        },
        editPreviewedNote: function (id) {
            if (this._isOpen) { return; }
            var fid = el8.appchart.mainFeeds.chart.removePreview(id);
            var obj = el8.util.feed.fromFeedItemId(fid);
            var note = el8.ptdata.fetch(obj);
            this.show(note);
        },

        /**
         * Externally adding items to the visit note
         */
        addReference: function (opts) {

            if (!this._isOpen) { return; }

            if (!this.allowAddReference()) {
                el8.uiwidget.alert('This reference in note action cannot be done when amending a note.');
                return;
            }

            opts = opts || {};
            var item = opts.item;
            var text = opts.text || null;
            var isAutoGen = opts.isAutoGen || false;
            var noNotify = opts.noNotify || false;

            if (text === null && item.is('LabResult') && opts.showPrevLabResultDates) {
                text = item.getNoteSummaryWithPrevDates();
            }

            /* This helper method translates the "item" into the ids and sectionNames
             * relevant for then creating a referenced item/document */
            var info = el8.appchart.visitNote.util.getReferenceInfo(item, isAutoGen);
            var handoutId = info.handoutId || null;

            // Look first for a caller-provided section then fallback to our reference info.
            var sectionName = opts.sectionName || info.sectionName || null;
            // and then adjust the sectionName for this particular visit template
            sectionName = that.getCurrFormTemplate().mapReferenceFn(sectionName, item);
            if (!sectionName) { return; }

            if (handoutId && sectionName === 'instr') {
                // special handling of handouts to make them show up properly in CCDAs
                var goalData = { 'text': 'Goal: ...' };
                var handoutData = {
                    'text': text || item.getNoteSummary(),
                    'documentId': null,
                    'labResultId': null,
                    'patientItemId': null,
                    'handoutId': handoutId
                };
                that.addParentChild(goalData, handoutData, sectionName);
                return;
            }

            if (!noNotify) {
                el8.appservice.notifier.notify('Added to note.');
            }

            // Check to see if we have a 'pe' or 'ros'; if so, this goes in a checklist
            if ((sectionName.startswith('pe') || sectionName.startswith('ros')) &&
                sectionName.split('-').length > 1) {
                that._addReferenceChecklist(item, text, sectionName);

            } else {
                // If the target section does not support referenced items (i.e. a textarea)
                if (!that._inputSections[sectionName].hasReferencedItems()) {
                    that._addReferenceTextarea(item, text, isAutoGen, info, sectionName);

                    // Regular bullet addition
                } else {
                    that._addReferenceStandard(item, text, isAutoGen, info, sectionName);
                }
            }

            if (item.is('LabResult') && sectionName === 'problem') {
                el8.appchart.mgr.notes.notifyRefreshReport(item.getReportId());
            }

            // if we're referencing in a document, copy over billing codes referenced by the doc tag
            if (info.documentId && item.getDocTagIds && item.getDocTagIds().length) {
                that._copyBillingCodesFromDocumentTags(item);
            }

            if (item.is('Report')) {
                that.addStarredResultsFromReport(item, isAutoGen, opts.showPrevLabResultDates || false);
            }
        },

        addStarredResultsFromReport: function (report, isAutoGen, showPrevLabResultDates) {
            if (!report.is('Report')) { return; }

            var resultRows = report.getStarredResults();
            resultRows.map(function (resultRow) {
                that.addReference({
                    item: resultRow,
                    isAutoGen: isAutoGen,
                    showPrevLabResultDates: showPrevLabResultDates
                });
            });
        },

        addDocumentTags: function (addlTagIds) {
            var that = this;
            var oldTagIds = this._model.getDocTagIds();
            var newTagIds = _.union(oldTagIds, addlTagIds);
            this._model.saveDocTags(newTagIds, {
                successCb: function () {
                    that._populateDocTagsWithTooltips();
                    that._updateBillFromTags(oldTagIds, newTagIds);
                }
            });
        },

        _copyBillingCodesFromDocumentTags: function (doc) {
            var addlTagIds = doc.getDocTagIds();
            var oldTagIds = this._model.getDocTagIds();
            var newTagIds = _.union(oldTagIds, addlTagIds);
            this._updateBillFromTags(oldTagIds, newTagIds);
        },

        _updateBillFromTags: function (oldTagIds, newTagIds) {
            var that = this;
            var theDelta = _.difference(newTagIds, oldTagIds); // newly added stuff
            var tagsToConsider = theDelta.map(function (id) {
                return el8.data.docTags.getById(id);
            });

            var dxMaps = [];
            var cpts = []; // might actually contain hcpcs, cpt2, etc.

            tagsToConsider.forEach(function (tag) {
                var code = tag.getBillingCpt();
                if (code) { cpts.push(code); }
                var dxMap = tag.getBillingDxMap();
                if (dxMap) { dxMaps.push(dxMap); }
            });

            cpts.forEach(function (cpt) {
                that.appendBillingCpt({ code: cpt });
            });

            if (dxMaps.length) { this.appendBillingDxMaps(dxMaps); }
        },

        /* Assumes that sectionName will be a string like 'pe-Diet': checklistType-fieldName */
        _addReferenceChecklist: function (item, text, sectionName) {
            var strs = sectionName.split('-');
            if (strs.length > 1) {
                sectionName = strs[0];
                var checklistFieldName = strs[1];

                if (this._inputSections[sectionName]) { this._inputSections[sectionName].show(); }
                // this third param is "doSave", not an opts dictionary
                this._checklists[sectionName].addEntry(checklistFieldName, text || item.getNoteSummary(), true);
            }
        },

        /* Adds a text bullet for manually referenced stuff but not auto-generated stuff
         * (e.g., just looking at a report). Updates the referenced item section either way */
        _addReferenceTextarea: function (item, text, isAutoGen, referenceInfo, sectionName) {
            // text
            if (!isAutoGen) {
                var bulletSpec = { 'text': text || item.getNoteSummary() };

                // for problems going into an assessment section,
                // even though we can't add imo_ids to a textarea, we'll
                // display the codes as text
                if (!text && /* don't override explicitly provided text */
                    item && el8.model.identify.isPatientProblem(item) && /* Problems only */
                    /* in assessment sections + narrative section of simple note only */
                    (_.contains(el8.util.consts.IMO_VISIT_SECTIONS, sectionName) || sectionName === 'narrative') &&
                    el8.data.currUser.isStructuredAssessmentsEnabled()) { /* and only if this featue is on */

                    bulletSpec['text'] = text || item.getNoteSummaryWithCodes();
                }

                var bullet = this._model.addBullet(sectionName.capitalize(), bulletSpec);
                this._inputSections[sectionName].addEntry(bullet, true);
            }

            var documentId = referenceInfo.documentId || null;
            var labResultId = referenceInfo.labResultId || null;
            var patientItemId = referenceInfo.patientItemId || null;

            // referenced items
            if (documentId) {
                if (this._inputSections['referenced'] &&
                    !this._inputSections['referenced'].isItemReferenced(documentId)) {
                    var bullet = this._model.addReferencedBullet(documentId, labResultId);
                    // "bullet" is null if documentId has somehow already been added to visit note
                    // but doesn't show in this visit note
                    if (bullet) {
                        this._inputSections['referenced'].addEntry(bullet, true);
                    }
                }
            }
            if (patientItemId) {
                this._model.associateItem(patientItemId);
            }
        },

        /* Adds a referenced item bullet for any manually referenced stuff and any
         * not-yet-added auto-generated stuff */
        _addReferenceStandard: function (item, text, isAutoGen, referenceInfo, sectionName) {
            var documentId = referenceInfo.documentId || null;
            var labResultId = referenceInfo.labResultId || null;
            var patientItemId = referenceInfo.patientItemId || null;
            var handoutId = referenceInfo.handoutId || null;
            var imoIds = referenceInfo.imoIds || null;

            if (!isAutoGen ||
                // If item is a lab result, check against the result id more specifically rather than
                // the document id of the report containing the result. Otherwise, adding a reference
                // to the report will prevent subsequent auto-adding of results from the report.
                (!(labResultId === null && this._inputSections[sectionName].isItemReferenced(documentId)) &&
                    !(this._inputSections[sectionName].isItemReferenced(labResultId)) &&
                    !(this._inputSections[sectionName].isItemReferenced(handoutId)) &&
                    !(this._inputSections[sectionName].isItemReferenced(patientItemId)))) {

                var bulletSpec = {
                    'text': text || item.getNoteSummary(),
                    'documentId': documentId,
                    'labResultId': labResultId,
                    'patientItemId': patientItemId,
                    'handoutId': handoutId
                };
                if (_.contains(el8.util.consts.IMO_VISIT_SECTIONS, sectionName) &&
                    el8.data.currUser.isStructuredAssessmentsEnabled()) {
                    // referenceInfo will hand us imoIds for any PatientProblem,
                    // but we only store them for assessment-focused sections
                    // (the same ones that would have an IMO autocomplete)
                    bulletSpec['imoIds'] = imoIds;
                }
                var bullet = this._model.addBullet(sectionName.capitalize(), bulletSpec);
                this._inputSections[sectionName].addEntry(bullet, true);
            }
        },

        addText: function (text, sectionName, addEntryOpts) {
            if (!this._isOpen) { return; }
            sectionName = this.getCurrFormTemplate().mapReferenceFn(sectionName);

            // Check to see if we have a 'pe' or 'ros'; if so, this goes in a checklist
            if ((sectionName.startswith('pe') || sectionName.startswith('ros')) &&
                sectionName.split('-').length > 1) {
                that._addReferenceChecklist(null, text, sectionName);
                // No return value, unlike the else block below. This should be
                // ok because the only place calling this addText function with
                // a "pe-*/ros-*" section name is React and those callers don't
                // expect a return value from this function.
            } else {
                var bullet = this._model.addBullet(sectionName.capitalize(), { 'text': text });
                this._inputSections[sectionName].addEntry(bullet, true, addEntryOpts);
                return bullet;
            }
        },

        addParentChild: function (parentData, childData, sectionName) {
            if (!this._isOpen) { return; }
            var that = this;
            sectionName = this.getCurrFormTemplate().mapReferenceFn(sectionName);
            var section = this._inputSections[sectionName];
            if (!section.isMultilist()) { return null; }

            var bullet = this._model.addBullet(sectionName.capitalize(), parentData);
            section.addEntry(bullet, true, {
                successCb: function () {
                    // childData is an obj maybe with .text
                    if (childData && childData.text) {
                        var subBullet = that._model.addBulletChild(bullet, childData);
                        section.addEntryChild(null, subBullet, true);
                    }
                }
            });
        },

        addProblemSubBullet: function (item, text) {
            if (!this._isOpen) { return; }
            var that = this;
            var section = this._inputSections['problem'] || this._inputSections['hpi'] || this._inputSections['narrative'];
            if (section) {
                if (section.isMultilist()) {
                    var sectionName = section.getName();
                    var bullets = this._model.getBulletSets()[sectionName.capitalize()].sorted(this._model.getCurrentEditId());
                    var info = el8.appchart.visitNote.util.getReferenceInfo(item);

                    var obj = {};
                    obj['text'] = text || item.getNoteSummary();
                    $.extend(obj, info);

                    if (bullets.length) {
                        el8.appchart.visitNote.subBulletDialog.show(bullets,
                            function (index) {
                                if (!el8.util.isNone(index)) {
                                    var bullet = bullets[index];
                                    var subBullet = that._model.addBulletChild(bullet, obj);
                                    section.addEntryChild(index, subBullet, true);
                                } else {
                                    var bullet = that.addText('-', sectionName, {
                                        successCb: function () {
                                            var subBullet = that._model.addBulletChild(bullet, obj);
                                            section.addEntryChild(null, subBullet, true);
                                        }
                                    });
                                }
                                if (item.is('LabResult') && sectionName === 'problem') {
                                    el8.appchart.mgr.notes.notifyRefreshReport(item.getReportId());
                                }
                            }
                        );
                    } else {
                        var bullet = that.addText('-', sectionName, {
                            successCb: function () {
                                var subBullet = that._model.addBulletChild(bullet, obj);
                                section.addEntryChild(null, subBullet, true);
                            }
                        });
                        if (item.is('LabResult') && sectionName === 'problem') {
                            el8.appchart.mgr.notes.notifyRefreshReport(item.getReportId());
                        }
                    }

                    if (item.is('Report')) {
                        that.addStarredResultsFromReport(item, false, false);
                    }
                } else {
                    this.addReference({ item: item, text: text, sectionName: section.getName() });
                }
            }
        },

        _createBill: function () {
            return el8.ptdata.visitNotes.createBill(this.getNoteId());
        },

        /**
         * Entrypoint to sync newly added/selected VN procedure (CPT code) to bill (service line):
         * - If Bill dialog is open, sync to the draft bill form state.
         * - If Bill dialog is closed, persist directly to the VN's bill.
         */
        appendBillingCpt: function (opts) {
            if (!this._isOpen) { return; }

            var cptObj, cptCode;
            if (opts.id) {
                cptObj = el8.data.cptCodes.getById(opts.id);
                cptCode = cptObj.getCode();
            } else {
                cptCode = opts.code;
            }

            if (!cptCode) {
                console.warn('[appendBillingCpt] failed to find cptCode for opts=', opts);
                return;
            }

            // Parse for modifiers. The base code will be at 0, mods after
            var parsedCodeArr = el8.data.cptCodes.parse(cptCode);

            if (el8.appchart.visitNote.billDialogMgr.isOpen()) {
                // This injects the CPT directly into the MLE of an open bill dlg which
                // will then persist CPT objects
                el8.appchart.visitNote.billDialogMgr.appendCpt(cptCode, parsedCodeArr);

                el8.appservice.notifier.notify('Adding procedure "' + cptCode + '" to draft bill...');
            } else {

                try {
                    // This is creating a CPT obj with the _spec
                    var bill = this._model.getBill() || this._createBill();
                    var existingCptCodes = bill.getCpts().map(function (c) { return c.getCpt(); });
                    if (_.contains(existingCptCodes, cptCode)) { return; } // duplicate

                    var _spec = { cpt: cptCode };

                    // Add modifiers to _spec if we have them
                    if (parsedCodeArr && parsedCodeArr[1]) {
                        // Change the base code
                        _spec.cpt = parsedCodeArr[0];

                        // Add the mods
                        _(_.range(1, 5)).each(function (idx) {
                            if (parsedCodeArr[idx]) {
                                _spec['modifier' + idx] = parsedCodeArr[idx]
                            }
                        });
                    }

                    // get the charge for this code, if invoicing on and it exists
                    if (el8.data.practiceSettings.isInvoicingEnabled() && cptObj) {
                        if (cptObj.getCharge()) { _.extend(_spec, { charge: cptObj.getCharge() }); }
                    }

                    var newCpt = el8.ptdata.model.note.billCpt(_spec);
                    bill.setCpts(bill.getCpts().concat(newCpt));
                    this._model.setBill(bill);

                    var saveBillSuccessCb = _.bind(this._populateBillingSummary, this);
                    this._model.saveEntireBill({
                        successCb: function () {
                            saveBillSuccessCb();

                            el8.appservice.notifier.notify('Added procedure "' + cptCode + '" to bill.');
                        },
                        errorCb: function (err) {
                            UIM && UIM.logError(
                                "[appendBillingCpt] failed to save bill error",
                                err,
                                {
                                    tags: {
                                        source: "appendBillingCpt",
                                    }
                                });
                        }
                    });
                }
                catch (ex) {
                    // RM-41223: Log when we unexpectedly fail to sync/persist cptCode to bill
                    UIM && UIM.logError(
                        "[appendBillingCpt] unexpected error encountered",
                        ex,
                        {
                            tags: {
                                source: "appendBillingCpt",
                            }
                        });
                }
            }
        },


        /**
         * Appends into the billing dialog if open or the VN. If the Icd9 billing dialog
         * is open, the codeIdSpec can contain "raw" icd9s. They are otherwise ignored.
         *
         * @param {object} codeIdSpec
         * @param {string[]} codeIdSpec.imoIds - List of IMO vendor code IDs
         */
        appendBillingDiagnoses: function (codeIdSpec, opts) {
            if (!this._isOpen) { return; }

            // This is used when adding many billing diagnoses in quick succession
            // (for example, exporting problems from the clinical profile). The
            // save should be skipped for all diagnoses except the last one.
            // Previously, exporting problems caused each diagnosis to fire a
            // save call, which resulted in bugs when those calls returned in
            // a different order than they were fired in. It's better to finish
            // adding them all, then fire a single save at the end.
            var skipSave = Boolean(opts && opts.skipSave);

            if (el8.appchart.visitNote.billDialogMgr.isOpen()) {
                el8.appchart.visitNote.billDialogMgr.appendDiagnoses(codeIdSpec);
            } else {

                // Initialize billing data to sync diagnoses to bill
                var bill = this._model.getBill() || this._createBill();
                var cpts = bill.getCpts();
                var firstCpt = _.first(bill.getCpts(cpts));
                if (!firstCpt) {
                    firstCpt = el8.ptdata.model.note.billCpt({});
                    bill.setCpts([firstCpt]);
                }

                var newDxs = [];

                // Turn any IMOs into DX lines
                var imoIds = codeIdSpec.imoIds || [];
                var unprocessableDx = [];

                imoIds.forEach(function (imoId) {
                    // Read from all/deleted IMO cache and check individual ICD-10 codes
                    // for validity (relative to date of service)
                    var imo = el8.data.imos.getByIdIncludingDeleted(imoId);

                    // IMO service DX mapping is likely cache invalidated and (possibly)
                    // no longer valid for billing. These DX codes will not be imported for billing
                    // and the practice should manually resolve (re-search, remove, replace, etc.)
                    // from the DX's source (e.g. patient problem, VN assessment)
                    if (!imo) {
                        unprocessableDx.push(imoId);
                        return;
                    }

                    var dxMaps = imo.getAsBillDxMaps();
                    dxMaps.forEach(function (dxMap) {
                        newDxs.push(el8.ptdata.model.note.billDx(dxMap));
                    });
                });

                // FUTURE: Refactor add-by-IMOs to find unprocessable DX earlier (to determine origin/source)
                if (unprocessableDx.length > 0) {
                    var unprocessableErrorText = "Error unable to append billing code(s): " + unprocessableDx.join(', ');
                    el8.appservice.notifier.notify(unprocessableErrorText);
                    console.error(unprocessableErrorText);
                }

                // Determine if we should sync all service lines or only the first
                var shouldBillDxSyncAllLines = el8Globals.FEATURES.BillDxImportConfig && el8.data.practiceSettings.isBillCodingDxImportAllLines();
                var targetCpts = shouldBillDxSyncAllLines ? cpts : [firstCpt];

                targetCpts.forEach(function (cpt) {
                    var existingDxs = cpt.getDxs();

                    // FUTURE: RM-37046: Logic to handle duplicate DXs, preserve primary DX, etc.
                    var nextDxs = _.uniq(existingDxs.concat(newDxs), false, function (dx) {
                        return dx.getIcd10Code().id;
                    });
                    cpt.setDxs(nextDxs);
                });

                this._model.setBill(bill);
                if (!skipSave) {
                    this._model.saveEntireBill({
                        successCb: _.bind(this._populateBillingSummary, this)
                    });
                }
            }
        },

        /**
         * Remove ICD-10 codes from billing for sync'ing Assessments to Bill.
         * If billing dialog is open, ICD-10 codes are removed from the bill draft.
         * If billing dialog is closed, ICD-10 codes are removed from the bill in database.
         * If no bill exists, do nothing.
         *
         * @param {object} codeIdSpec
         * @param {string[]} codeIdSpec.icd10Codes - List of ICD-10 codes, e.g. ["R05.3", "R05.9"]
         */
        removeBillingDiagnoses: function (codeIdSpec) {
            if (!this._isOpen) { return; }
            if (!codeIdSpec || !codeIdSpec.icd10Codes) { return; }

            if (el8.appchart.visitNote.billDialogMgr.isOpen()) {
                el8.appchart.visitNote.billDialogMgr.removeDiagnoses(codeIdSpec);
            } else {
                var bill = this._model.getBill();
                if (!bill) return;

                // Get set of ICD-10 codes to remove
                var removeDxs = codeIdSpec.icd10Codes.slice();

                var isDirtyBill = false;

                // Determine if we should sync DX removals for all matches or only the first match
                var shouldBillDxSyncAllLines = el8Globals.FEATURES.BillDxImportConfig && el8.data.practiceSettings.isBillCodingDxImportAllLines();

                var cpts = bill.getCpts();
                cpts.forEach(function (cpt) {
                    var isDirtyCpt = false;
                    var currentDxs = cpt.getDxs();

                    var cleanDxs = currentDxs.filter(function (dx) {
                        var icd10 = dx.getIcd10Code();
                        if (!removeDxs.includes(icd10.code)) return true;

                        // Update removed DXs to sync only the first encountered ICD-10 code match
                        if (!shouldBillDxSyncAllLines) {
                            removeDxs = removeDxs.filter(function (code) {
                                return code !== icd10.code
                            });
                        }

                        // Found removable ICD-10 code in service line
                        isDirtyBill = true;
                        isDirtyCpt = true;
                        return false;
                    });

                    if (isDirtyCpt) {
                        cpt.setDxs(cleanDxs);
                    }
                });

                // Re-save bill IFF ICD-10 code(s) were removed
                if (isDirtyBill) {
                    this._model.setBill(bill);
                    this._model.saveEntireBill({
                        successCb: _.bind(this._populateBillingSummary, this)
                    });
                }
            }
        },

        appendBillingDxMaps: function (dxMaps) {
            if (!this._isOpen) { return; }

            if (!el8.appchart.visitNote.billDialogMgr.isOpen()) {
                var bill = this._model.getBill() || this._createBill();
                var lastCpt = _.last(bill.getCpts());
                if (!lastCpt) {
                    lastCpt = el8.ptdata.model.note.billCpt({});
                    bill.setCpts([lastCpt]);
                }

                var newDxs = [];
                dxMaps.forEach(function (dxMap) {
                    newDxs.push(el8.ptdata.model.note.billDx(dxMap));
                });

                var existingDxs = lastCpt.getDxs();
                // dedup on icd10s
                lastCpt.setDxs(_.uniq(existingDxs.concat(newDxs), false, function (dx) {
                    return dx.getIcd10Code().id;
                }));

                this._model.setBill(bill);
                this._model.saveEntireBill({
                    successCb: _.bind(this._populateBillingSummary, this)
                });
            }
        },

        appendBillingNote: function (note) {
            if (!this._isOpen) { return; }

            if (!el8.appchart.visitNote.billDialogMgr.isOpen()) {
                var newText = note;
                var bill = this._model.getBill() || this._createBill();
                if (bill.getNotes()) {
                    newText = bill.getNotes() + '; ' + note;
                }
                bill.setNotes(newText);
                this._model.setBill(bill);
                this._model.saveEntireBill({
                    successCb: _.bind(this._populateBillingSummary, this)
                });
            }
        },

        useChecklistTemplate: function (templateId) {
            if (!this._isOpen) { return; }

            var template = el8.data.checklistTemplates.getById(templateId);
            if (!template) { return; }
            var templateType = template.getType();

            if (this._model.getTemplate() === 'oneCol.oneField') {
                // simple notes don't have PE/ROS sections, so just stick the text directly in
                var templateAsText = el8.template.app.data.checklistTemplates.templateAsText({
                    template: template.asSoyMap()
                });
                this.addText(templateAsText, templateType);
                return;
            }

            var checklistSection = this._checklists[templateType];
            if (!checklistSection) { return; }

            this._checklists[templateType].populateTemplate(template);
        },

        // called whenever a realtime update has led us to refresh the bill for this note
        renderUpdatedBill: function (updatedNoteId) {
            this._populateBillingSummary(updatedNoteId);
        },

        updateVisitDateElt: function () {
            var displayDate = this._model.getDisplayDate();
            if (displayDate) {
                this._visitDateElt.text(displayDate.asDateTimeString());
            }
        },

        addNewOrder: function (order) {

            if (!this._isOpen) { return; }

            var sectionName = this.getCurrFormTemplate().mapOwnedDocFn(order);
            if (this._inputSections[sectionName]) {
                var bullet = this._model.addOwnedDocumentBullet(order, sectionName.capitalize());
                if (bullet) {
                    this._inputSections[sectionName].addEntry(bullet, true);
                }
            }
            el8.appservice.notifier.notify(order.getNotifyText('ADD_TO_NOTE'));

            // Mark MU section if is referral order
            if (order.is('ReferralOrder')) {
                this.markTransitionOfCareType('referring');
            }
        },

        removeNewOrder: function (order) {
            if (!this._isOpen) { return; }

            var sectionName = this.getCurrFormTemplate().mapOwnedDocFn(order);
            if (this._inputSections[sectionName]) {
                this._inputSections[sectionName].removeOwnedDoc(order.getId());
            }
        },

        addProblemWithDetails: function (problem, sectionName) {
            var sectionName = this.getCurrFormTemplate().mapReferenceFn(sectionName || null, problem);
            var section = this._inputSections[sectionName];
            if (section) {
                var that = this;
                var problemInfo = el8.appchart.visitNote.util.getReferenceInfo(problem);
                problemInfo['text'] = problem.getNoteSummary();
                var bullet = this._model.addBullet(sectionName.capitalize(), problemInfo);
                section.addEntry(bullet, true, {
                    successCb: function () {
                        if (problem.getDetails()) {
                            var subBullet = that._model.addBulletChild(bullet, { 'text': problem.getDetails() });
                            section.addEntryChild(null, subBullet, true);
                        }
                    }
                });
            }
        },

        getLabResultsInProblemBullets: function (reportId) {
            var result = {};
            var bullets = this._model.getBulletSets()['Problem'].all();
            for (var j = 0; j < bullets.length; j++) {
                if (bullets[j].getLabResultId()) {
                    if (!result[bullets[j].getDocumentId()]) {
                        result[bullets[j].getDocumentId()] = [];
                    }
                    result[bullets[j].getDocumentId()].push(bullets[j].getLabResultId());
                }
                var children = bullets[j].getChildrenSet().sorted(this._model.getCurrentEditId());
                for (var i = 0; i < children.length; i++) {
                    if (children[i].getLabResultId()) {
                        if (!result[children[i].getDocumentId()]) {
                            result[children[i].getDocumentId()] = [];
                        }
                        result[children[i].getDocumentId()].push(children[i].getLabResultId());
                    }
                }
            }
            return result[reportId] || [];
        },

        highlightLabResultSubBullet: function (section, bullet, index, resultId) {
            var children = bullet.getChildrenSet().sorted(this._model.getCurrentEditId());
            for (var i = 0; i < children.length; i++) {
                if (children[i].getLabResultId() === resultId) {
                    section.highlightEntryChild(index, i);
                    return true;
                }
            }
            return false;
        },

        getBulletByProblemId: function (sectionName, problemId) {
            if (!problemId) { return; }
            var bullets = this._model.getBulletSets()[sectionName.capitalize()].sorted(this._model.getCurrentEditId());
            for (var i = 0; i < bullets.length; i++) {
                if (bullets[i].getPatientItemId() === problemId) {
                    return {
                        bullet: bullets[i],
                        index: i
                    };
                }
            }
            return null;
        },

        removeBullet: function (bulletId) {
            if (!this._isOpen) { return; }

            var bullet = this._model.getBulletById(bulletId);
            if (!bullet) { return; }

            var sectionName = bullet.getCategory().toLowerCase();
            if (this._inputSections[sectionName]) {
                this._inputSections[sectionName].removeOwnedDoc(bullet.getDocumentId());
            }
        },

        autoImportProblemWithLabs: function (problem, labResults, opts) {
            var skipSave = Boolean(opts && opts.skipSave);

            /** First, add to HPI/Problem section **/
            (function (that) {

                // First get section information
                var section = that._inputSections['problem'] || that._inputSections['hpi'] || that._inputSections['narrative'];
                if (!section) { return; }
                var sectionName = section.getName();

                // Get problem bullet (create if needed) and add sub-bullets
                var existing = that.getBulletByProblemId(sectionName, problem.getId());

                if (existing) {
                    for (var i = 0; i < labResults.length; i++) {
                        var labInfo = el8.appchart.visitNote.util.getReferenceInfo(labResults[i]);
                        labInfo['text'] = labResults[i].getNoteSummary();
                        var alreadyRef = that.highlightLabResultSubBullet(
                            section, existing['bullet'], existing['index'], labResults[i].getId());
                        if (!alreadyRef) {
                            var subBullet = that._model.addBulletChild(existing['bullet'], labInfo);
                            section.addEntryChild(existing['index'], subBullet, true);
                        }
                    }

                } else {
                    // Create new bullet
                    var problemInfo = el8.appchart.visitNote.util.getReferenceInfo(problem);
                    problemInfo['text'] = problem.getNoteSummary();
                    var bullet = that._model.addBullet(sectionName.capitalize(), problemInfo);
                    section.addEntry(bullet, true, {
                        successCb: function () {
                            for (var i = 0; i < labResults.length; i++) {
                                var labInfo = el8.appchart.visitNote.util.getReferenceInfo(labResults[i]);
                                labInfo['text'] = labResults[i].getNoteSummary();
                                var subBullet = that._model.addBulletChild(bullet, labInfo);
                                section.addEntryChild(null, subBullet, true);
                            }
                        }
                    });
                }
            })(this);

            /** Now add to Assessments **/
            (function (that) {
                var section = that._inputSections['assessment'] || that._inputSections['assessplan'];
                if (!section) { return; }
                var sectionName = section.getName();

                // Get assessment bullet (create if needed)
                var existing = that.getBulletByProblemId(sectionName, problem.getId());

                if (!existing) {
                    var problemInfo = el8.appchart.visitNote.util.getReferenceInfo(problem);
                    problemInfo['text'] = problem.getNoteSummary() + ' - ';
                    var bullet = that._model.addBullet(sectionName.capitalize(), problemInfo);
                    section.addEntry(bullet, true);
                }
            })(this);

            // Now add the codes to the bill via any IMOs on this problem.
            // We ignore legacy bare ICD9-based problems now
            (function (that) {
                if (!el8Globals['FEATURES']['AutoImportBilling']) { return; }
                if (problem.getImoIds().length) {
                    that.appendBillingDiagnoses({ imoIds: problem.getImoIds() }, { skipSave: skipSave });
                }
            })(this);

            /** Now add to the data section **/
            (function (that) {
                var mapped = {};
                var reports = [];
                for (var i = 0; i < labResults.length; i++) {
                    var reportId = labResults[i].getReportId();
                    if (!mapped[reportId]) {
                        mapped[reportId] = true;
                        reports.push(el8.ptdata.fetchById(reportId));
                    }
                }
                for (var i = 0; i < reports.length; i++) {
                    that.addReference({ item: reports[i], isAutoGen: true });
                    el8.appchart.mgr.notes.notifyRefreshReport(reports[i].getId());
                }
            })(this);

        },

        markAllAssessments: function (str) {
            var section = this._inputSections['assessment'] || this._inputSections['assessplan'];
            if (section) {
                if (section.isMultilist()) { // only do for multilist
                    var mlEntries = section.getMultilistEntries();
                    for (var i = 0; i < mlEntries.length; i++) {
                        var val = mlEntries[i].getParentInputVal();
                        var newVal;
                        if (val.trim().endswith('-')) {
                            newVal = val + str;
                        } else {
                            newVal = val + ' - ' + str;
                        }
                        mlEntries[i].setParentInputVal(newVal, { doHighlight: true });
                    }
                }
            }
        },

        /**
         * External helper methods
         */
        getBill: function () {
            var bill = this._model.getBill() || this._createBill();

            var lastCpt = _.last(bill.getCpts());

            if (!lastCpt) {
                lastCpt = el8.ptdata.model.note.billCpt({});
                bill.setCpts([lastCpt]);
            }
            return bill
        },

        getNote: function () { return this._model; },
        getNoteId: function () {
            return (this._model ? this._model.getId() : null);
        },
        getNoteDate: function () {
            return (this._model ? this._model.getDisplayDate() : null);
        },
        isOpen: function () { return this._isOpen; },
        isEdit: function () { return Boolean(this._model && this._model.getCurrentEditId()); },
        getForm: function () { return this._form; },
        isTwoColComplex: function () { return this._currTemplate.startswith('twoCol.complex'); },
        getAssessmentFieldType: function () {
            var typeMap = el8.data.visitNoteFormTemplates.getByIdentifier(this._currTemplate)['sectionTypeMap'];
            return typeMap['assessment'] || typeMap['assessplan'];
        },

        // Right now we have not yet built the ability to ref in note for parts of visit notes
        // that are NOT the twoCol.complex template.  So we created this special helper method
        allowAddReference: function () {
            return !this.isEdit() ||
                (this.isEdit() && this.isTwoColComplex());
        },

        disable: function () {
            that._form.disable();
            $('.el8FormLink', this._container).addClass('disabled');
            $('.el8StandardLink', this._container).addClass('disabled');
        },

        enable: function () {
            that._form.enable();
            $('.el8FormLink', this._container).removeClass('disabled');
            $('.el8StandardLink', this._container).removeClass('disabled');
        },

        repopulate: function (data) {
            that.close(false);
            $('.el8FormLink', this._container).removeClass('disabled');
            $('.el8StandardLink', this._container).removeClass('disabled');
            that._isOpen = false;
            that.show(el8.ptdata.model.note.visit(data));
            setTimeout(function () {
                that._form.enable();
            }, 0);
        },

        _trackStart: function (sourceName) {
            // This really SHOULD just be fired immediately when the visit note is opened.
            // However it's already used in a variety of amplitude charts (that may or may
            // not be important).
            // It's spread across the _trackStart and _flushStartEvent calls to fix an issue
            // where the note is closed before this event is dispatched, at which point the
            // `that.model` would be null (responsible for one of our most frequent sentry
            // issues). During this fix we COULD have removed the delay, and removed
            // the number of cds attribute from this event completely but we decided not
            // to open that can of worms.
            var eventProps = {
                'document id': that._model.getId(),
                'note type': that.getCurrFormTemplate().displayName,
            };

            if (sourceName) {
                eventProps.source = sourceName;
            }

            that._bufferedStartEvent = {
                eventProps: eventProps,
                createdAt: new Date()
            };
            // Delaying by a few seconds as a temporary hack, to allow CDS alerts
            // to (hopefully) fully load. This is the much easier alternative to
            // untangling the way CDS alerts are loaded (combination of sync/
            // async requests, duplicate requests, loaded in multiple steps),
            // and should not be needed anymore if we can get CDS alerts to
            // load in a cleaner way and attach this tracking call to the completion
            // of that load.
            that._startEventTimer = setTimeout(function () {
                that._flushStartEvent();
            }, 5000);
        },

        _flushStartEvent: function () {
            clearTimeout(that._startEventTimer);
            if (that._bufferedStartEvent == undefined) return;

            var eventProps = that._bufferedStartEvent.eventProps;
            var createdAt = that._bufferedStartEvent.createdAt;
            try {
                // This will fail when the visit note has already been closed
                eventProps['number of cds'] = el8.appchart.visitNote.alertFeed.getIndexSize();
            } catch (_err) {}
            el8.util.amplitude.logEventWithTimestamp('start note', eventProps, createdAt);
            that._bufferedStartEvent = null;
        },

        _trackCompletion: function (actionName) {
            that._flushStartEvent();
            el8.util.amplitude.logEvent('complete note', {
                action: actionName,
                'document id': that._model.getId(),
                'number of cds': el8.appchart.visitNote.alertFeed.getIndexSize()
            });
        }
    };

    el8.appchart.cqmRefresh.register({
        endCb: function (url, statusChanged) {
            if (statusChanged) {
                var note = that.getNote();
                if (note) {
                    el8.appchart.visitNote.refreshAlertFeed(note, true);
                }
            }
        }
    });

    return that;

})();
